<template>
  <div class="bet-view" id="betviewScrollx">
    <!-- Single / Multi Single -->
    <div v-if="!isMulp" class="bet-mode-zone" id="betModeZone">
      <div class="left">
        <span>{{ betLang['BETTING.LBL_SINGLE'] }}</span>
        <span class="bet-single-count">
          {{betFormList.length}}
        </span>
      </div>
      <div class="right">
        <label class="check-box" v-if="allowComboBet && selectedBettype.betTypId!='5' && account.oneWallet!='1'">
          <input type="checkbox" v-model="isBetCombo" />
          <div class="check-wrap relative-position" :class="{'active':isBetCombo}" style="margin-right:5px;"></div>
          {{ betLang['BETTING.LBL_COMBO'] }}
        </label>
        <!--<span>
          <i @mouseover="hoverInfo=true" @mouseleave="hoverInfo=false" aria-hidden="true" role="presentation" class="bet-info q-icon icon-tips c-icon" id="merge-info" style="font-size: 14px;"></i>
        </span>
        <div v-if="hoverInfo" role="tooltip" class="q-tooltip q-tooltip--style q-position-engine no-pointer-events bet-bg-tooltip" style="visibility: visible; top: 254.146px; left: 15px;">
          <div style="width:170px;min-height:60px;padding-top:5px;padding-bottom:10px; padding-left:5px;text-align:start;line-height: 1.5;word-break: break-all;">
            {{betLang["BETTING.LBL_COMBO_NOTE"]}}
          </div>
        </div>-->
      </div>
    </div>
    <div v-if="!isMulp" data-container="single-container" class="bet-single" id="singleContainer">
      <template v-for="(data, key) in betFormList" v-if="betFormList">
        <div class="q-card q-card--flat no-shadow" :class="bettingResultClass(data, key)">
          <div class="q-card__section q-card__section--vert" :class="{'bet-item':chkBettingSuccess(data) || chkBetPending(data)}">
            <div class="vrow" :class="{'first-row now-wrap':chkBettingSuccess(data)}">
              <div class="col bet-league-name">{{data.league}}</div>
              <div class="col-auto" :class="{'col-delete': chkIsBetting(data, 'del'),'bet-icon-info': chkBettingSuccess(data)}" 
                @click="deleteMatch(data.eventObj.eveid, data, key)"> <!--key delete from bet form-->
                <template v-if="chkIsBetting(data) && !wgNotsuccessreject.includes(data.wgStatus)">
                  <i aria-hidden="true" role="presentation" class="bet-del q-icon icon-del c-icon" style="font-size: 12px;"></i>
                </template>
                <template v-else-if="data.wgStatus=='2' || data.wgStatus=='0'">
                  <i aria-hidden="true" role="presentation" class="q-icon icon-success c-icon" style="font-size: 18px;"> </i>
                </template>
                <template v-if="data.wgStatus=='1'">
                  <span id="dg_icon" class="pending_wager"></span>
                </template>
              </div>
            </div>
            <div class="vrow" v-if="data.betType != '14'"> <!--not outright-->
              <div class="col bet-against">
                <span class="home-vs-away"> 
                  <span v-html="data.ta"></span>
                  <span class="bet-pk">v</span>
                  <span v-html="data.tb"></span>
                </span>
                <span class="score" v-if="data.eventObj && data.eventObj.rbinfo">
                  <template v-if="data.sprtid=='1'">
                    ({{data.rbscoa}}-{{data.rbscob}})
                  </template>
                </span>
              </div>
            </div>
            <div class="vrow" v-if="chkBettingSuccess(data)">
              <div class="col match-time">
                <template v-if="selectedLang==2 || selectedLang==3">
                  {{data.eventObj.dt | date('MMMDo HH:mm')}}
                </template>
                <template v-else>
                  {{data.eventObj.dt | date('MM/DD HH:mm')}}
                </template>
              </div>
            </div>
            <div class="bet-content">
              <div class="vrow">
                <div class="col bet-play-game">
                <label class="bet-play-text">
                    <template v-if="data.sprtid == 255"><span class="sport-name" style="display: inline-flex; align-items: center;"><label class="sport-img img36 SP"></label>[{{sportTableLang.table['SPORT_TABLE.SPECIAL_EVENT']}}]</span><br></template>
                    <span class="bet-match-playing" v-if="data.eventObj && data.eventObj.rbstatus">[{{ sportAllBetLang["ALL_BET.LBL_LIVE"] }}]</span> 
                    {{ getPtBtCapt(data)}}
                    <span class="bet-handicap-name" style="height:15px !important"> {{ getOddsTypeCap(data) }} </span>
                </label>
                </div>
              </div>
              <div class="vrow no-wrap">
                <div class="col bet-play-team yb-fontsize13">
                  <div class="bet-team-handicap">
                    <template v-if="data.betType == '2' || data.betType == '9' || data.betType == '46' || data.betType == '47' || data.betType == '48' || data.betType == '49' || data.betType=='80' || data.betType=='81' || data.betType=='82' || data.betType=='83'">
                      <template v-if="data.tbet == 'a'">
                        {{ sportAllBetLang["ALL_BET.LBL_OVER"] }}
                      </template>
                      <template v-else-if="data.tbet == 'b'">
                        {{ sportAllBetLang["ALL_BET.LBL_UNDER"] }}
                      </template>
                    </template>
                    <template v-else-if="data.betType == '32' || data.betType == '33' || data.betType == '76' || data.betType == '79'">
                      <template v-if="data.tbet == 'a'">
                        {{ sportAllBetLang["ALL_BET.LBL_YES"] }}
                      </template>
                      <template v-else-if="data.tbet == 'b'">
                        {{ sportAllBetLang["ALL_BET.LBL_NO"] }}
                      </template>
                    </template>
                    <template v-else-if="data.betType == '21' || data.betType == '27' || data.betType == '36' || data.betType == '37' || data.betType == '38' || data.betType == '39' || data.betType == '40' || data.betType == '41' || data.betType == '42' || data.betType == '43' || data.betType == '44' || data.betType == '45'">
                      <template v-if="data.tbet == 'a'">
                        {{ sportAllBetLang["ALL_BET.LBL_HOME"] }} 
                      </template>
                      <template v-else-if="data.tbet == 'b'">
                        {{ sportAllBetLang["ALL_BET.LBL_AWAY"] }}
                      </template>
                      <template v-else-if="data.tbet == 'x'">
                        {{ sportAllBetLang["ALL_BET.LBL_DRAW"] }}
                      </template>
                      <template v-if="data.betType == '21' || data.betType == '27'">
                        ({{ h1x2Header(data.hdp, data.tbet) }})
                      </template>
                    </template>
                    <template v-else-if="data.betType == '50' || data.betType == '51'">
                      <template v-if="data.tbet == 'h1'">
                        {{ sportAllBetLang["ALL_BET.LBL_HWB1"] }}
                      </template>
                      <template v-else-if="data.tbet == 'h2'">
                        {{ sportAllBetLang["ALL_BET.LBL_HWB2"] }}
                      </template>
                      <template v-else-if="data.tbet == 'h3'">
                        {{ sportAllBetLang["ALL_BET.LBL_HWB3"] }}
                      </template>
                      <template v-else-if="data.tbet == 'h4'">
                        {{ sportAllBetLang["ALL_BET.LBL_HWB4M"] }}
                      </template>
                      <template v-else-if="data.tbet == 'a1'">
                        {{ sportAllBetLang["ALL_BET.LBL_AWB1"] }}
                      </template>
                      <template v-else-if="data.tbet == 'a2'">
                        {{ sportAllBetLang["ALL_BET.LBL_AWB2"] }}
                      </template>
                      <template v-else-if="data.tbet == 'a3'">
                        {{ sportAllBetLang["ALL_BET.LBL_AWB3"] }}
                      </template>
                      <template v-else-if="data.tbet == 'a4'">
                        {{ sportAllBetLang["ALL_BET.LBL_AWB4M"] }}
                      </template>
                      <template v-else-if="data.tbet == 'sd'">
                        {{ sportAllBetLang["ALL_BET.LBL_AS"] }}
                      </template>
                      <template v-else-if="data.tbet == 'ng'">
                        {{ sportAllBetLang["ALL_BET.LBL_NG"] }}
                      </template>
                    </template>
                    <template v-else-if="data.betType == '77' || data.betType == '78'">
                      <template v-if="data.tbet == 'h1'">
                        {{ sportAllBetLang["ALL_BET.LBL_HWB1R"] }}
                      </template>
                      <template v-else-if="data.tbet == 'h2'">
                        {{ sportAllBetLang["ALL_BET.LBL_HWB2R"] }}
                      </template>
                      <template v-else-if="data.tbet == 'h3'">
                        {{ sportAllBetLang["ALL_BET.LBL_HWB3R"] }}
                      </template>
                      <template v-else-if="data.tbet == 'h4'">
                        {{ sportAllBetLang["ALL_BET.LBL_HWB4RM"] }}
                      </template>
                      <template v-else-if="data.tbet == 'a1'">
                        {{ sportAllBetLang["ALL_BET.LBL_AWB1R"] }}
                      </template>
                      <template v-else-if="data.tbet == 'a2'">
                        {{ sportAllBetLang["ALL_BET.LBL_AWB2R"] }}
                      </template>
                      <template v-else-if="data.tbet == 'a3'">
                        {{ sportAllBetLang["ALL_BET.LBL_AWB3R"] }}
                      </template>
                      <template v-else-if="data.tbet == 'a4'">
                        {{ sportAllBetLang["ALL_BET.LBL_AWB4RM"] }}
                      </template>
                      <template v-else-if="data.tbet == 'sd'">
                        {{ sportAllBetLang["ALL_BET.LBL_BB_AS"] }}
                      </template>
                      <template v-else-if="data.tbet == 'ng'">
                        {{ sportAllBetLang["ALL_BET.LBL_NG"] }}
                      </template>
                    </template>
                    <template v-else-if="data.betType == '28' || data.betType == '29' || data.betType == '30' || data.betType == '31'">
                      <template v-if="data.tbet == 'a'">
                        {{ sportAllBetLang["ALL_BET.LBL_1HT"] }}
                      </template>
                      <template v-else-if="data.tbet == 'b'">
                        {{ sportAllBetLang["ALL_BET.LBL_2HT"] }}
                      </template>
                      <template v-else-if="data.tbet == 'x'">
                        {{ sportAllBetLang["ALL_BET.LBL_DRAW"] }}
                      </template>
                    </template>
                    <template v-else-if="data.betType == '25'">
                      <template v-if="data.tbet == 'h_1_5'">
                        {{ sportAllBetLang['ALL_BET.LBL_HOME'] }} {{ sportAllBetLang["ALL_BET.LBL_WIN_BY_1T5"] }}
                      </template>
                      <template v-else-if="data.tbet == 'h_6_10'">
                        {{ sportAllBetLang['ALL_BET.LBL_HOME'] }} {{ sportAllBetLang["ALL_BET.LBL_WIN_BY_6T10"] }}
                      </template>
                      <template v-else-if="data.tbet == 'h_11_15'">
                        {{ sportAllBetLang['ALL_BET.LBL_HOME'] }} {{ sportAllBetLang["ALL_BET.LBL_WIN_BY_11T15"] }}
                      </template>
                      <template v-else-if="data.tbet == 'h_16_20'">
                        {{ sportAllBetLang['ALL_BET.LBL_HOME'] }} {{ sportAllBetLang["ALL_BET.LBL_WIN_BY_16T20"] }}
                      </template>
                      <template v-else-if="data.tbet == 'h_21_25'">
                        {{ sportAllBetLang['ALL_BET.LBL_HOME'] }} {{ sportAllBetLang["ALL_BET.LBL_WIN_BY_21T25"] }}
                      </template>
                      <template v-else-if="data.tbet == 'h_26_x'">
                        {{ sportAllBetLang['ALL_BET.LBL_HOME'] }} {{ modifyTitle('h_26_x') }}
                      </template>
                      <template v-else-if="data.tbet == 'a_1_5'">
                        {{ sportAllBetLang['ALL_BET.LBL_AWAY'] }} {{ sportAllBetLang["ALL_BET.LBL_WIN_BY_1T5"] }}
                      </template>
                      <template v-else-if="data.tbet == 'a_6_10'">
                        {{ sportAllBetLang['ALL_BET.LBL_AWAY'] }} {{ sportAllBetLang["ALL_BET.LBL_WIN_BY_6T10"] }}
                      </template>
                      <template v-else-if="data.tbet == 'a_11_15'">
                        {{ sportAllBetLang['ALL_BET.LBL_AWAY'] }} {{ sportAllBetLang["ALL_BET.LBL_WIN_BY_11T15"] }}
                      </template>
                      <template v-else-if="data.tbet == 'a_16_20'">
                        {{ sportAllBetLang['ALL_BET.LBL_AWAY'] }} {{ sportAllBetLang["ALL_BET.LBL_WIN_BY_16T20"] }}
                      </template>
                      <template v-else-if="data.tbet == 'a_21_25'">
                        {{ sportAllBetLang['ALL_BET.LBL_AWAY'] }} {{ sportAllBetLang["ALL_BET.LBL_WIN_BY_21T25"] }}
                      </template>
                      <template v-else-if="data.tbet == 'a_26_x'">
                        {{ sportAllBetLang['ALL_BET.LBL_AWAY'] }} {{ modifyTitle('a_26_x') }}
                      </template>
                    </template>
                    <template v-else-if="data.betType == '52'">
                      <template v-if="data.tbet == 'hf'">
                        {{ sportAllBetLang["ALL_BET.LBL_HFG"] }}
                      </template>
                      <template v-else-if="data.tbet == 'hl'">
                        {{ sportAllBetLang["ALL_BET.LBL_HLG"] }}
                      </template>
                      <template v-else-if="data.tbet == 'af'">
                        {{ sportAllBetLang["ALL_BET.LBL_AFG"] }}
                      </template>
                      <template v-else-if="data.tbet == 'al'">
                        {{ sportAllBetLang["ALL_BET.LBL_ALG"] }}
                      </template>
                      <template v-else-if="data.tbet == 'ng'">
                        {{ sportAllBetLang["ALL_BET.LBL_NG"] }}
                      </template>
                    </template>
                    <template v-else-if="data.betType == '53' || data.betType == '54' || data.betType == '55' || data.betType == '56'">
                      <template v-if="data.tbet == '0_5'">
                        {{ sportAllBetLang["ALL_BET.LBL_05"] }}
                      </template>
                      <template v-else-if="data.tbet == '1_6'">
                        {{ sportAllBetLang["ALL_BET.LBL_16"] }}
                      </template>
                      <template v-else-if="data.tbet == '2_7'">
                        {{ sportAllBetLang["ALL_BET.LBL_27"] }}
                      </template>
                      <template v-else-if="data.tbet == '3_8'">
                        {{ sportAllBetLang["ALL_BET.LBL_38"] }}
                      </template>
                      <template v-else-if="data.tbet == '4_9'">
                        {{ sportAllBetLang["ALL_BET.LBL_49"] }}
                      </template>
                    </template>
                    <template v-else-if="data.betType == '19' || data.betType == '20'">
                      <template v-if="data.tbet == 'ha'">
                        {{ sportAllBetLang["ALL_BET.LBL_HOME_OR_AWAY"] }}
                      </template>
                      <template v-else-if="data.tbet == 'hd'">
                        {{ sportAllBetLang["ALL_BET.LBL_HOME_OR_DRAW"] }}
                      </template>
                      <template v-else>
                        {{ sportAllBetLang["ALL_BET.LBL_AWAY_OR_DRAW"] }}
                      </template>
                    </template>
                    <template v-else-if="data.betType == '57' || data.betType == '58'">
                      <template v-if="data.tbet == 'ng0'">
                        {{ sportAllBetLang["ALL_BET.LBL_0"] }}
                      </template>
                      <template v-else-if="data.tbet == 'ng1'">
                        {{ sportAllBetLang["ALL_BET.LBL_1"] }}
                      </template>
                      <template v-else-if="data.tbet == 'ng2'">
                        {{ sportAllBetLang["ALL_BET.LBL_2"] }}
                      </template>
                      <template v-else-if="data.tbet == 'ng3'">
                        {{ sportAllBetLang["ALL_BET.LBL_3"] }}
                      </template>
                      <template v-else-if="data.tbet == 'ng4'">
                        {{ sportAllBetLang["ALL_BET.LBL_4"] }}
                      </template>
                      <template v-else-if="data.tbet == 'ng5'">
                        {{ sportAllBetLang["ALL_BET.LBL_5"] }}
                      </template>
                      <template v-else-if="data.tbet == 'ng6'">
                        {{ sportAllBetLang["ALL_BET.LBL_6more"] }}
                      </template>
                    </template>
                    <template v-else-if="data.betType == '59' || data.betType == '73'">
                      <template v-if="data.tbet == 'ha'">
                        {{ sportAllBetLang['ALL_BET.LBL_OVER'] }} 
                        <template v-if="!chkIsBetting(data)"> {{ getHdpCapt(data)}} </template>
                        <template v-else>
                          <label class="yb-number-bold handicap" :class="{'bet-handicap':data.hdpChg}">
                            {{ getHdpCapt(data)}}
                          </label>
                        </template>
                         {{ sportAllBetLang['ALL_BET.AND']}} {{ sportAllBetLang['ALL_BET.LBL_ODD']}}
                      </template>
                      <template v-else-if="data.tbet == 'hb'">
                        {{ sportAllBetLang['ALL_BET.LBL_OVER'] }} 
                        <template v-if="!chkIsBetting(data)"> {{ getHdpCapt(data)}} </template>
                        <template v-else>
                          <label class="yb-number-bold handicap" :class="{'bet-handicap':data.hdpChg}">
                            {{ getHdpCapt(data)}}
                          </label>
                        </template>
                         {{ sportAllBetLang['ALL_BET.AND']}} {{ sportAllBetLang['ALL_BET.LBL_EVEN']}}
                      </template>
                      <template v-else-if="data.tbet == 'aa'">
                        {{ sportAllBetLang['ALL_BET.LBL_UNDER'] }} 
                        <template v-if="!chkIsBetting(data)"> {{ getHdpCapt(data)}} </template>
                        <template v-else>
                          <label class="yb-number-bold handicap" :class="{'bet-handicap':data.hdpChg}">
                            {{ getHdpCapt(data)}}
                          </label>
                        </template>
                         {{ sportAllBetLang['ALL_BET.AND']}} {{ sportAllBetLang['ALL_BET.LBL_ODD']}}
                      </template>
                      <template v-else-if="data.tbet == 'ab'">
                        {{ sportAllBetLang['ALL_BET.LBL_UNDER'] }} 
                        <template v-if="!chkIsBetting(data)"> {{ getHdpCapt(data)}} </template>
                        <template v-else>
                          <label class="yb-number-bold handicap" :class="{'bet-handicap':data.hdpChg}">
                            {{ getHdpCapt(data)}}
                          </label>
                        </template>
                         {{ sportAllBetLang['ALL_BET.AND']}} {{ sportAllBetLang['ALL_BET.LBL_EVEN']}}
                      </template>
                    </template>
                    <template v-else-if="data.betType == '60' || data.betType == '61'">
                      <template v-if="data.tbet == 'ha'">
                        {{ sportAllBetLang['ALL_BET.LBL_OVER'] }} 
                        <template v-if="!chkIsBetting(data)"> {{ getHdpCapt(data)}} </template>
                        <template v-else>
                          <label class="yb-number-bold handicap" :class="{'bet-handicap':data.hdpChg}">
                            {{ getHdpCapt(data)}}
                          </label>
                        </template>
                         {{ sportAllBetLang['ALL_BET.AND']}} {{ sportAllBetLang['ALL_BET.LBL_YES']}}
                      </template>
                      <template v-else-if="data.tbet == 'hb'">
                        {{ sportAllBetLang['ALL_BET.LBL_UNDER'] }} 
                        <template v-if="!chkIsBetting(data)"> {{ getHdpCapt(data)}} </template>
                        <template v-else>
                          <label class="yb-number-bold handicap" :class="{'bet-handicap':data.hdpChg}">
                            {{ getHdpCapt(data)}}
                          </label>
                        </template>
                         {{ sportAllBetLang['ALL_BET.AND']}} {{ sportAllBetLang['ALL_BET.LBL_YES']}}
                      </template>
                      <template v-else-if="data.tbet == 'aa'">
                        {{ sportAllBetLang['ALL_BET.LBL_OVER'] }} 
                        <template v-if="!chkIsBetting(data)"> {{ getHdpCapt(data)}} </template>
                        <template v-else>
                          <label class="yb-number-bold handicap" :class="{'bet-handicap':data.hdpChg}">
                            {{ getHdpCapt(data)}}
                          </label>
                        </template>
                         {{ sportAllBetLang['ALL_BET.AND']}} {{ sportAllBetLang['ALL_BET.LBL_NO']}}
                      </template>
                      <template v-else-if="data.tbet == 'ab'">
                        {{ sportAllBetLang['ALL_BET.LBL_UNDER'] }} 
                        <template v-if="!chkIsBetting(data)"> {{ getHdpCapt(data)}} </template>
                        <template v-else>
                          <label class="yb-number-bold handicap" :class="{'bet-handicap':data.hdpChg}">
                            {{ getHdpCapt(data)}}
                          </label>
                        </template>
                         {{ sportAllBetLang['ALL_BET.AND']}} {{ sportAllBetLang['ALL_BET.LBL_NO']}}
                      </template>
                    </template>
                    <template v-else>
                      <span v-html="data.tbetcapt"></span>
                    </template>
                    <template v-if='data.betType=="1" || data.betType=="2" || data.betType=="8" || data.betType=="9" || data.betType=="46" || data.betType=="47" || data.betType=="48" || data.betType=="49" || data.betType=="63" || data.betType=="64" || data.betType=="68" || data.betType=="69" || data.betType=="80" || data.betType=="81" || data.betType=="82" || data.betType=="83"'>
                      <template v-if="!chkIsBetting(data)">{{ getHdpCapt(data)}} </template>
                      <template v-else>
                        <label class="yb-number-bold handicap" :class="{'bet-handicap':data.hdpChg}">
                          {{ getHdpCapt(data)}}
                        </label>
                        <!-- <label class="yb-number-bold handicap" :class="{'bet-handicap':data.hdpChg}" v-else-if="(data.hdp==0 && (data.betType == '1' ||data.betType == '8'))">
                            0
                        </label> -->
                      </template>
                    </template>
                  </div>
                </div>
              </div>
              <div class="vrow">
                <div class="col bet-odds-value" :class="getOddChange(data)">
                  <span class="odds-value yb-number-bold" style="float: left;">
                    <span>@</span>
                    <template v-if="data.betType == 7 || data.betType == 16">
                      {{ new Number(parseFloat(data.odd)) }}
                    </template>
                    <template v-else>
                      <template v-if="betting.success">
                        {{ getDecimalDisplay(betting.success.data.betting[key].odd, betting.success.data.betting[key].sprtid) }}
                      </template>
                      <template v-else>
                        {{ getDecimalDisplay(data.odd, data.sprtid) }}
                      </template>
                    </template>
                  </span>
                </div>
                <div class="auto-col">
                  <span class="invalid" v-if="(betting.error && betting.error.code=='N-4000-N') || (isBetCombo && data.error && data.error.code=='N-4000-N')">
                    {{ sportAllBetLang["ALL_BET.BET_CLOSE"] }}
                  </span> <!--event closed -->
                  <span class="invalid" v-if="data.wgStatus=='-1'"> <!-- reject -->
                    {{ betLang["BETTING.LBL_REJECT_B"] }}
                  </span>
                  <!--span class="appoint" style="display:none;"> +预约 </span>-->
                </div>
              </div>
            </div>
            <div class="vrow bet-single-input" v-if="chkIsBetting(data, 'input')">
              <div data-check-money="0" class="col relative-position">
                <div v-if="(betting.error && betting.error.code=='N-4000-N') || (isBetCombo && data.error && data.error.code=='N-4000-N')" class="cathectic-shade"></div>
                <template v-if="!isBetCombo">
                  <input inputmode="decimal" 
                    :placeholder="betMinMaxVal" 
                    autocomplete="off"
                    onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                    class="bet-input input-border singleInput"
                    :class="JSErr" 
                    size="8"
                    :maxlength="amountMaxLength"
                    ref="betAmount" 
                    v-model="betAmount"
                    @keydown.enter.prevent="confirmBetForm" />
                  <div class="bet-input-close" @click="clearInput()" v-if="betAmount.length>0">
                    <i aria-hidden="true" role="presentation" class="q-icon icon-failure c-icon" style="font-size: 12px;"></i>
                  </div>
                </template>
                <template v-else>
                  <!-- MultiSingle -->
                  <input inputmode="decimal" 
                    :placeholder="eventBetMinMax(data)" 
                    autocomplete="off"
                    onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                    class="bet-input input-border betComboInput" 
                    :class="JSErr" 
                    size="8"
                    :maxlength="amountMaxLength"
                    :ref="'betAmount'+key" 
                    v-model="betComboAmount[key].value"
                    v-on:input="setbetComboKeyboard(key)"
                    @keydown.enter.prevent="confirmBetForm" 
                    :disabled="data.error"/>
                  <div class="bet-input-close" @click="clearInput(key)" v-if="Object.keys(betComboAmount[key].value).length>0">
                    <i aria-hidden="true" role="presentation" class="q-icon icon-failure c-icon" style="font-size: 12px;"></i>
                  </div>
                </template>
              </div>
            </div>
            <div class="vrow bet-win yb-fontsize12">
              <template v-if="chkIsBetting(data)">
                <div class="col df-jb"> {{ sportAllBetLang["ALL_BET.HIGH_WIN"] }} </div>
                <div class="col-auto bet-win-money yb-number-bold">
                  <template v-if="isBetCombo">
                    {{ betPossiblePayout(key) | decimal(2) }}
                  </template>
                  <template v-else>
                    {{ possiblePayout | decimal(2) }}
                  </template>
                </div>
              </template>
              <template v-else-if="chkBettingSuccess(data) || chkBetPending(data)">
                <div class="col" style="height: 18px;">{{ betLang['BETTING.LBL_STAKE'] }}</div>
                <div class="col-auto" style="height: 18px;max-width:100px">{{ sportAllBetLang["ALL_BET.HIGH_WIN"] }}</div>
              </template>
            </div>
            <template v-if="promotionFlag && !((betting.success || (isBetCombo && wgSuccess.includes(data.wgStatus))) && !data.error) && isSportValidPromo(data.eventObj, data.betType) && !promotionBetStatus">
              <div class="promotion_join_box">
                <div class="promotion_join_img"></div>
                <div class="promotion_join">{{langList.promotion['promotion.promotion_join_get']}}</div>
              </div>
            </template>
            <div class="vrow bet-win2 yb-fontsize12" v-if="chkBettingSuccess(data) || chkBetPending(data)">
              <div class="col black-money-text">
                <template v-if="chkBettingSuccess(data)">
                  <template v-if="isBetCombo">
                    {{ data.betAmt | decimal(2) }}
                  </template>
                  <template v-else>
                    {{ betting.success.data.betAmt | decimal(2) }}
                  </template>
                </template>
                <template v-else-if="!isBetCombo && chkBetPending(data)">{{ betting.pending.data.betAmt | decimal(2) }}</template>
                <template v-else>{{ data.betAmt | decimal(2) }}</template>
              </div>
              <div class="col-auto black-money-text">
                <template v-if="!isBetCombo">{{ betSuccessPPayout(null, betting.selectedBetAllup) | decimal(2) }}</template>
                <template v-else>{{ betSuccessPPayout(data, betting.selectedBetAllup) | decimal(2) }}</template>
              </div>
            </div>
          </div>
          
          <div class="bet-keyboard-zone q-card__section q-card__section--vert" v-if="chkIsBetting(data, 'keyboard')">
            <div class="vrow bet-keyboard bet-keyboard-content">
              <div class="col">
                <div class="q-gutter-xs keyboard-zone">
                  <div class="keyboard-btn" :class="{' disable-key-btn': checkAllowKeyboard(data, keyboardAllow.min, key, 'min')}" @click="addsum(betting.betAmountOption.min, key)">
                    <div class="keyboard-btn-text" :class="{'text-disable':checkAllowKeyboard(data, keyboardAllow.min, key, 'min')}">+{{ betting.betAmountOption.min }}</div>
                  </div>
                  <div class="keyboard-btn" :class="{' disable-key-btn': checkAllowKeyboard(data, keyboardAllow.med, key, 'med')}" @click="addsum(betting.betAmountOption.med, key)">
                    <div class="keyboard-btn-text" :class="{'text-disable': checkAllowKeyboard(data, keyboardAllow.med, key, 'med')}">+{{ betting.betAmountOption.med }}</div>
                  </div>
                  <div class="keyboard-btn" :class="{' disable-key-btn': checkAllowKeyboard(data, keyboardAllow.big, key, 'big')}" @click="addsum(betting.betAmountOption.big, key)">
                    <div class="keyboard-btn-text" :class="{'text-disable':checkAllowKeyboard(data, keyboardAllow.big, key, 'big')}">+{{ betting.betAmountOption.big }}</div>
                  </div>
                  <div class="keyboard-btn" :class="{' disable-key-btn': checkAllowKeyboard(data, keyboardAllow.big2, key, 'big2')}" @click="addsum(betting.betAmountOption.big2, key)">
                    <div class="keyboard-btn-text" :class="{'text-disable': checkAllowKeyboard(data, keyboardAllow.big2, key, 'big2')}">+{{ betting.betAmountOption.big2 }}</div>
                  </div>
                  <div class="keyboard-btn" :class="{' disable-key-btn': checkAllowKeyboard(data, keyboardAllow.big3, key, 'big3')}" @click="addsum(betting.betAmountOption.big3, key)">
                    <div class="keyboard-btn-text" :class="{'text-disable': checkAllowKeyboard(data, keyboardAllow.big3, key, 'big3')}">+{{ commasAmount(betting.betAmountOption.big3) }}</div>
                  </div>
                  <div class="keyboard-btn" :class="{' disable-key-btn':isBetCombo}" @click="addsum(betting.betAmountOption.max, key)">
                    <div class="keyboard-btn-text" :class="{'text-disable':isBetCombo}">
                      {{ langList.sportMinibetLang['SPORT_MINIBET.MAX'] }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <!-- Handle oddChange, hdpChange, wgPending, wgSuccess -->
        <div class="bet-confirm-message text-center yb-fontsize12 ab" 
          :class="getBetConfirmClass(data, key)" 
          v-if="!isBetCombo && wgSts.includes(data.wgStatus) || (isBetCombo && checkShowErrMsg(data, jsError, key))">

          <template v-if="data.wgStatus==1">{{betLang['BETTING.LBL_PENDING_BET']}}</template>
          <template v-else-if="(betting.success || (isBetCombo && wgSuccess.includes(data.wgStatus))) && !data.error">
            {{betLang['BETTING.LBL_BET_CONFIRM']}}
          </template>
          <template v-else>
            <template v-if="data.oddChg">{{ betLang["BETTING.LBL_ODDS_CHANGE"] }}</template>
            <template v-if="data.hdpChg">
              <template v-if="data.oddChg">,</template>
              {{ betLang["BETTING.LBL_HANDICAP_CHANGE"] }}
            </template>
            <template v-else-if="data.error && data.error.code!='N-4000-N'">
              {{ data.error.message }}<br>{{ data.error.code }}
            </template>
            <template v-else-if="!isBetCombo && jsError.error">
              {{ jsError.msg }}
            </template>
            <template v-else-if="isBetCombo && (betCombo_jsError[key]!=undefined && betCombo_jsError[key].error)">
              {{ betCombo_jsError[key].msg }}
            </template>
          </template>
        </div>
      </template>

      <div v-if="isBetCombo && betFormList.length>1 && !betting.betcombosuccess && !betting.pending" id="betMultiple" class="relative-position bet-multiple bet-card q-card q-card--flat no-shadow" is_forward="-1" style="margin-top:5px">
        <div class="q-card__section q-card__section--vert">
          <div class="vrow">
            <div class="line"></div>
            <div class="col">{{ sportAllBetLang["ALL_BET.MULTI_SINGLES"] }}</div>
          </div>
          <div class="vrow bet-multiple-input yb-flex-nowrap">
            <div class="col bet-count">
              <span>{{betFormList.length}}</span>
              <span class="operation-symbol">×</span>
            </div>
            <div data-check-money="0" class="col-auto right-input">
              <input inputmode="decimal" 
                :placeholder="betMinMaxVal" 
                autocomplete="off"
                onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                class="bet-input input-border" 
                :class="JSErr" 
                size="8"
                :maxlength="amountMaxLength"
                ref="betAmount" 
                v-model="allBetComboAmount"
                v-on:input="setALLbetComboAmount()"
                @keydown.enter.prevent="confirmBetForm" />
              <div class="bet-input-close" @click="clearInput(null, 'all')" v-if="allBetComboAmount!=''">
                <i aria-hidden="true" role="presentation" class="q-icon icon-failure c-icon" style="font-size: 12px;"></i>
              </div>
            </div>
          </div>
          <div class="vrow bet-win yb-fontsize12">
            <div class="col df-jb"> {{ sportAllBetLang["ALL_BET.HIGH_WIN"] }} </div>
            <div class="col-auto bet-win-money yb-number-bold">
              {{ betPossiblePayout() | decimal(2) }}
            </div>
          </div>
          <div class="vrow bet-keyboard bet-keyboard-content">
            <div class="col">
              <div class="q-gutter-xs keyboard-zone">
                <div class="keyboard-btn" :class="{' disable-key-btn': checkAllowKeyboard(null, keyboardAllow.min, 'all', 'min') }" @click="addsum(betting.betAmountOption.min)">
                  <div class="keyboard-btn-text">+{{ betting.betAmountOption.min }}</div>
                </div>
                <div class="keyboard-btn" :class="{' disable-key-btn': checkAllowKeyboard(null, keyboardAllow.med, 'all', 'med') }" @click="addsum(betting.betAmountOption.med)">
                  <div class="keyboard-btn-text">+{{ betting.betAmountOption.med }}</div>
                </div>
                <div class="keyboard-btn" :class="{' disable-key-btn': checkAllowKeyboard(null, keyboardAllow.big, 'all', 'big') }" @click="addsum(betting.betAmountOption.big)">
                  <div class="keyboard-btn-text">+{{ betting.betAmountOption.big }}</div>
                </div>
                <div class="keyboard-btn" :class="{' disable-key-btn': checkAllowKeyboard(null, keyboardAllow.big2, 'all', 'big2') }" @click="addsum(betting.betAmountOption.big2)">
                  <div class="keyboard-btn-text">+{{ betting.betAmountOption.big2 }}</div>
                </div>
                <div class="keyboard-btn" :class="{' disable-key-btn': checkAllowKeyboard(null, keyboardAllow.big3, 'all', 'big3') }" @click="addsum(betting.betAmountOption.big3)">
                  <div class="keyboard-btn-text">+{{ commasAmount(betting.betAmountOption.big3) }}</div>
                </div>
                <div class="keyboard-btn disable-key-btn" @click="addsum(betting.betAmountOption.max)">
                  <div class="keyboard-btn-text text-disable">
                    {{ langList.sportMinibetLang['SPORT_MINIBET.MAX'] }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- END Single / Multi Single -->

    <!-- MULP -->
    <div v-if="isMulp" class="bet-mix height-full full-height bet-layout">
      <div class="auto-wrap no-wrap column" id="mulpContainer">
        <div class="scroll-wrap"> <!--record-scoll-wrap-->

          <!-- bet slip -->
          <div class="bet-mix-record" v-if="betting.success || betting.pending">
            <template v-for="(data, key) in betFormList" v-if="betFormList">
              <div class="bet-mix-record-item-card q-card q-card--flat no-shadow" :class="{'bet-mix-record-item-first':key==0}">
                <div class="q-card__section q-card__section--vert">
                  <div class="vrow">
                    <div class="col bet-league-name">{{data.league}}</div>
                  </div>
                  <div class="vrow">
                    <div class="col bet-against">
                      <span class="home-vs-away"><span v-html="data.ta"></span><span class="bet-pk">v</span><span v-html="data.tb"></span>
                        <template v-if="data.eventObj && data.eventObj.rbinfo">({{data.eventObj.rbinfo.scoa}}-{{data.eventObj.rbinfo.scob}})</template>
                      </span>
                    </div>
                  </div>
                  <div class="vrow">
                    <div class="col match-time">
                      <template v-if="selectedLang==2 || selectedLang==3">
                        {{data.eventObj.dt | date('MMMDo HH:mm')}}
                      </template>
                      <template v-else>
                        {{data.eventObj.dt | date('MM/DD HH:mm')}}
                      </template>
                    </div>
                  </div>
                  <div class="bet-content">
                    <div class="vrow">
                      <div class="col bet-play-game">
                        <label class="bet-play-text">
                          <label class="bet-match-playing" v-if="data.eventObj && data.eventObj.rbstatus">{{ sportAllBetLang["ALL_BET.LBL_LIVE"] }}</label>
                            {{ getPtBtCapt(data)}}
                          <label class="bet-handicap-name">{{getOddsTypeCap(data)}} </label>
                        </label>
                      </div>
                      <div class="col-auto"></div>
                    </div>
                    <div class="vrow no-wrap">
                      <!-- <div class="col bet-play-team yb-fontsize14">
                        <span class="part-one">{{data.tbetcapt}}</span>
                        <span class="part-two"></span>
                      </div> -->
                      <div class="col bet-play-team">
                        <label class="bet-team-handicap">
                          <template v-if="data.betType == '2' || data.betType == '9' || data.betType == '46' || data.betType == '47' || data.betType == '48' || data.betType == '49' || data.betType=='80' || data.betType=='81' || data.betType=='82' || data.betType=='83'">
                            <template v-if="data.tbet == 'a'">
                              {{ sportAllBetLang["ALL_BET.LBL_OVER"] }}
                            </template>
                            <template v-else-if="data.tbet == 'b'">
                              {{ sportAllBetLang["ALL_BET.LBL_UNDER"] }}
                            </template>
                          </template>
                          <template v-else-if="data.betType == '32' || data.betType == '33' || data.betType == '76' || data.betType == '79'">
                            <template v-if="data.tbet == 'a'">
                              {{ sportAllBetLang["ALL_BET.LBL_YES"] }}
                            </template>
                            <template v-else-if="data.tbet == 'b'">
                              {{ sportAllBetLang["ALL_BET.LBL_NO"] }}
                            </template>
                          </template>
                          <template v-else-if="data.betType == '21' || data.betType == '27' || data.betType == '36' || data.betType == '37' || data.betType == '38' || data.betType == '39' || data.betType == '40' || data.betType == '41' || data.betType == '42' || data.betType == '43' || data.betType == '44' || data.betType == '45'">
                            <template v-if="data.tbet == 'a'">
                              {{ sportAllBetLang["ALL_BET.LBL_HOME"] }} 
                            </template>
                            <template v-else-if="data.tbet == 'b'">
                              {{ sportAllBetLang["ALL_BET.LBL_AWAY"] }}
                            </template>
                            <template v-else-if="data.tbet == 'x'">
                              {{ sportAllBetLang["ALL_BET.LBL_DRAW"] }}
                            </template>
                            <template v-if="data.betType == '21' || data.betType == '27'">
                              ({{ h1x2Header(data.hdp, data.tbet) }})
                            </template>
                          </template>
                          <template v-else-if="data.betType == '50' || data.betType == '51'">
                            <template v-if="data.tbet == 'h1'">
                              {{ sportAllBetLang["ALL_BET.LBL_HWB1"] }}
                            </template>
                            <template v-else-if="data.tbet == 'h2'">
                              {{ sportAllBetLang["ALL_BET.LBL_HWB2"] }}
                            </template>
                            <template v-else-if="data.tbet == 'h3'">
                              {{ sportAllBetLang["ALL_BET.LBL_HWB3"] }}
                            </template>
                            <template v-else-if="data.tbet == 'h4'">
                              {{ sportAllBetLang["ALL_BET.LBL_HWB4M"] }}
                            </template>
                            <template v-else-if="data.tbet == 'a1'">
                              {{ sportAllBetLang["ALL_BET.LBL_AWB1"] }}
                            </template>
                            <template v-else-if="data.tbet == 'a2'">
                              {{ sportAllBetLang["ALL_BET.LBL_AWB2"] }}
                            </template>
                            <template v-else-if="data.tbet == 'a3'">
                              {{ sportAllBetLang["ALL_BET.LBL_AWB3"] }}
                            </template>
                            <template v-else-if="data.tbet == 'a4'">
                              {{ sportAllBetLang["ALL_BET.LBL_AWB4M"] }}
                            </template>
                            <template v-else-if="data.tbet == 'sd'">
                              {{ sportAllBetLang["ALL_BET.LBL_AS"] }}
                            </template>
                            <template v-else-if="data.tbet == 'ng'">
                              {{ sportAllBetLang["ALL_BET.LBL_NG"] }}
                            </template>
                          </template>
                          <template v-else-if="data.betType == '77' || data.betType == '78'">
                            <template v-if="data.tbet == 'h1'">
                              {{ sportAllBetLang["ALL_BET.LBL_HWB1R"] }}
                            </template>
                            <template v-else-if="data.tbet == 'h2'">
                              {{ sportAllBetLang["ALL_BET.LBL_HWB2R"] }}
                            </template>
                            <template v-else-if="data.tbet == 'h3'">
                              {{ sportAllBetLang["ALL_BET.LBL_HWB3R"] }}
                            </template>
                            <template v-else-if="data.tbet == 'h4'">
                              {{ sportAllBetLang["ALL_BET.LBL_HWB4RM"] }}
                            </template>
                            <template v-else-if="data.tbet == 'a1'">
                              {{ sportAllBetLang["ALL_BET.LBL_AWB1R"] }}
                            </template>
                            <template v-else-if="data.tbet == 'a2'">
                              {{ sportAllBetLang["ALL_BET.LBL_AWB2R"] }}
                            </template>
                            <template v-else-if="data.tbet == 'a3'">
                              {{ sportAllBetLang["ALL_BET.LBL_AWB3R"] }}
                            </template>
                            <template v-else-if="data.tbet == 'a4'">
                              {{ sportAllBetLang["ALL_BET.LBL_AWB4RM"] }}
                            </template>
                            <template v-else-if="data.tbet == 'sd'">
                              {{ sportAllBetLang["ALL_BET.LBL_BB_AS"] }}
                            </template>
                            <template v-else-if="data.tbet == 'ng'">
                              {{ sportAllBetLang["ALL_BET.LBL_NG"] }}
                            </template>
                          </template>
                          <template v-else-if="data.betType == '28' || data.betType == '29' || data.betType == '30' || data.betType == '31'">
                            <template v-if="data.tbet == 'a'">
                              {{ sportAllBetLang["ALL_BET.LBL_1HT"] }}
                            </template>
                            <template v-else-if="data.tbet == 'b'">
                              {{ sportAllBetLang["ALL_BET.LBL_2HT"] }}
                            </template>
                            <template v-else-if="data.tbet == 'x'">
                              {{ sportAllBetLang["ALL_BET.LBL_DRAW"] }}
                            </template>
                          </template>
                          <template v-else-if="data.betType == '25'">
                            <template v-if="data.tbet == 'h_1_5'">
                              {{ sportAllBetLang['ALL_BET.LBL_HOME'] }} {{ sportAllBetLang["ALL_BET.LBL_WIN_BY_1T5"] }}
                            </template>
                            <template v-else-if="data.tbet == 'h_6_10'">
                              {{ sportAllBetLang['ALL_BET.LBL_HOME'] }} {{ sportAllBetLang["ALL_BET.LBL_WIN_BY_6T10"] }}
                            </template>
                            <template v-else-if="data.tbet == 'h_11_15'">
                              {{ sportAllBetLang['ALL_BET.LBL_HOME'] }} {{ sportAllBetLang["ALL_BET.LBL_WIN_BY_11T15"] }}
                            </template>
                            <template v-else-if="data.tbet == 'h_16_20'">
                              {{ sportAllBetLang['ALL_BET.LBL_HOME'] }} {{ sportAllBetLang["ALL_BET.LBL_WIN_BY_16T20"] }}
                            </template>
                            <template v-else-if="data.tbet == 'h_21_25'">
                              {{ sportAllBetLang['ALL_BET.LBL_HOME'] }} {{ sportAllBetLang["ALL_BET.LBL_WIN_BY_21T25"] }}
                            </template>
                            <template v-else-if="data.tbet == 'h_26_x'">
                              {{ sportAllBetLang['ALL_BET.LBL_HOME'] }} {{ modifyTitle('h_26_x') }}
                            </template>
                            <template v-else-if="data.tbet == 'a_1_5'">
                              {{ sportAllBetLang['ALL_BET.LBL_AWAY'] }} {{ sportAllBetLang["ALL_BET.LBL_WIN_BY_1T5"] }}
                            </template>
                            <template v-else-if="data.tbet == 'a_6_10'">
                              {{ sportAllBetLang['ALL_BET.LBL_AWAY'] }} {{ sportAllBetLang["ALL_BET.LBL_WIN_BY_6T10"] }}
                            </template>
                            <template v-else-if="data.tbet == 'a_11_15'">
                              {{ sportAllBetLang['ALL_BET.LBL_AWAY'] }} {{ sportAllBetLang["ALL_BET.LBL_WIN_BY_11T15"] }}
                            </template>
                            <template v-else-if="data.tbet == 'a_16_20'">
                              {{ sportAllBetLang['ALL_BET.LBL_AWAY'] }} {{ sportAllBetLang["ALL_BET.LBL_WIN_BY_16T20"] }}
                            </template>
                            <template v-else-if="data.tbet == 'a_21_25'">
                              {{ sportAllBetLang['ALL_BET.LBL_AWAY'] }} {{ sportAllBetLang["ALL_BET.LBL_WIN_BY_21T25"] }}
                            </template>
                            <template v-else-if="data.tbet == 'a_26_x'">
                              {{ sportAllBetLang['ALL_BET.LBL_AWAY'] }} {{ modifyTitle('a_26_x') }}
                            </template>
                          </template>
                          <template v-else-if="data.betType == '52'">
                            <template v-if="data.tbet == 'hf'">
                              {{ sportAllBetLang["ALL_BET.LBL_HFG"] }}
                            </template>
                            <template v-else-if="data.tbet == 'hl'">
                              {{ sportAllBetLang["ALL_BET.LBL_HLG"] }}
                            </template>
                            <template v-else-if="data.tbet == 'af'">
                              {{ sportAllBetLang["ALL_BET.LBL_AFG"] }}
                            </template>
                            <template v-else-if="data.tbet == 'al'">
                              {{ sportAllBetLang["ALL_BET.LBL_ALG"] }}
                            </template>
                            <template v-else-if="data.tbet == 'ng'">
                              {{ sportAllBetLang["ALL_BET.LBL_NG"] }}
                            </template>
                          </template>
                          <template v-else-if="data.betType == '53' || data.betType == '54' || data.betType == '55' || data.betType == '56'">
                            <template v-if="data.tbet == '0_5'">
                              {{ sportAllBetLang["ALL_BET.LBL_05"] }}
                            </template>
                            <template v-else-if="data.tbet == '1_6'">
                              {{ sportAllBetLang["ALL_BET.LBL_16"] }}
                            </template>
                            <template v-else-if="data.tbet == '2_7'">
                              {{ sportAllBetLang["ALL_BET.LBL_27"] }}
                            </template>
                            <template v-else-if="data.tbet == '3_8'">
                              {{ sportAllBetLang["ALL_BET.LBL_38"] }}
                            </template>
                            <template v-else-if="data.tbet == '4_9'">
                              {{ sportAllBetLang["ALL_BET.LBL_49"] }}
                            </template>
                          </template>
                          <template v-else-if="data.betType == '19' || data.betType == '20'">
                            <template v-if="data.tbet == 'ha'">
                              {{ sportAllBetLang["ALL_BET.LBL_HOME_OR_AWAY"] }}
                            </template>
                            <template v-else-if="data.tbet == 'hd'">
                              {{ sportAllBetLang["ALL_BET.LBL_HOME_OR_DRAW"] }}
                            </template>
                            <template v-else>
                              {{ sportAllBetLang["ALL_BET.LBL_AWAY_OR_DRAW"] }}
                            </template>
                          </template>
                          <template v-else-if="data.betType == '57' || data.betType == '58'">
                            <template v-if="data.tbet == 'ng0'">
                              {{ sportAllBetLang["ALL_BET.LBL_0"] }}
                            </template>
                            <template v-else-if="data.tbet == 'ng1'">
                              {{ sportAllBetLang["ALL_BET.LBL_1"] }}
                            </template>
                            <template v-else-if="data.tbet == 'ng2'">
                              {{ sportAllBetLang["ALL_BET.LBL_2"] }}
                            </template>
                            <template v-else-if="data.tbet == 'ng3'">
                              {{ sportAllBetLang["ALL_BET.LBL_3"] }}
                            </template>
                            <template v-else-if="data.tbet == 'ng4'">
                              {{ sportAllBetLang["ALL_BET.LBL_4"] }}
                            </template>
                            <template v-else-if="data.tbet == 'ng5'">
                              {{ sportAllBetLang["ALL_BET.LBL_5"] }}
                            </template>
                            <template v-else-if="data.tbet == 'ng6'">
                              {{ sportAllBetLang["ALL_BET.LBL_6more"] }}
                            </template>
                          </template>
                          <template v-else-if="data.betType == '59' || data.betType == '73'">
                            <template v-if="data.tbet == 'ha'">
                              {{ sportAllBetLang['ALL_BET.LBL_OVER'] }} 
                              <template v-if="!chkIsBetting(data)"> {{ getHdpCapt(data)}} </template>
                              <template v-else>
                                <label class="yb-number-bold handicap" :class="{'bet-handicap':data.hdpChg}">
                                  {{ getHdpCapt(data)}}
                                </label>
                              </template>
                               {{ sportAllBetLang['ALL_BET.AND']}} {{ sportAllBetLang['ALL_BET.LBL_ODD']}}
                            </template>
                            <template v-else-if="data.tbet == 'hb'">
                              {{ sportAllBetLang['ALL_BET.LBL_OVER'] }} 
                              <template v-if="!chkIsBetting(data)"> {{ getHdpCapt(data)}} </template>
                              <template v-else>
                                <label class="yb-number-bold handicap" :class="{'bet-handicap':data.hdpChg}">
                                  {{ getHdpCapt(data)}}
                                </label>
                              </template>
                               {{ sportAllBetLang['ALL_BET.AND']}} {{ sportAllBetLang['ALL_BET.LBL_EVEN']}}
                            </template>
                            <template v-else-if="data.tbet == 'aa'">
                              {{ sportAllBetLang['ALL_BET.LBL_UNDER'] }} 
                              <template v-if="!chkIsBetting(data)"> {{ getHdpCapt(data)}} </template>
                              <template v-else>
                                <label class="yb-number-bold handicap" :class="{'bet-handicap':data.hdpChg}">
                                  {{ getHdpCapt(data)}}
                                </label>
                              </template>
                               {{ sportAllBetLang['ALL_BET.AND']}} {{ sportAllBetLang['ALL_BET.LBL_ODD']}}
                            </template>
                            <template v-else-if="data.tbet == 'ab'">
                              {{ sportAllBetLang['ALL_BET.LBL_UNDER'] }} 
                              <template v-if="!chkIsBetting(data)"> {{ getHdpCapt(data)}} </template>
                              <template v-else>
                                <label class="yb-number-bold handicap" :class="{'bet-handicap':data.hdpChg}">
                                  {{ getHdpCapt(data)}}
                                </label>
                              </template>
                               {{ sportAllBetLang['ALL_BET.AND']}} {{ sportAllBetLang['ALL_BET.LBL_EVEN']}}
                            </template>
                          </template>
                          <template v-else-if="data.betType == '60' || data.betType == '61'">
                            <template v-if="data.tbet == 'ha'">
                              {{ sportAllBetLang['ALL_BET.LBL_OVER'] }} 
                              <template v-if="!chkIsBetting(data)"> {{ getHdpCapt(data)}} </template>
                              <template v-else>
                                <label class="yb-number-bold handicap" :class="{'bet-handicap':data.hdpChg}">
                                  {{ getHdpCapt(data)}}
                                </label>
                              </template>
                               {{ sportAllBetLang['ALL_BET.AND']}} {{ sportAllBetLang['ALL_BET.LBL_YES']}}
                            </template>
                            <template v-else-if="data.tbet == 'hb'">
                              {{ sportAllBetLang['ALL_BET.LBL_UNDER'] }} 
                              <template v-if="!chkIsBetting(data)"> {{ getHdpCapt(data)}} </template>
                              <template v-else>
                                <label class="yb-number-bold handicap" :class="{'bet-handicap':data.hdpChg}">
                                  {{ getHdpCapt(data)}}
                                </label>
                              </template>
                               {{ sportAllBetLang['ALL_BET.AND']}} {{ sportAllBetLang['ALL_BET.LBL_YES']}}
                            </template>
                            <template v-else-if="data.tbet == 'aa'">
                              {{ sportAllBetLang['ALL_BET.LBL_OVER'] }} 
                              <template v-if="!chkIsBetting(data)"> {{ getHdpCapt(data)}} </template>
                              <template v-else>
                                <label class="yb-number-bold handicap" :class="{'bet-handicap':data.hdpChg}">
                                  {{ getHdpCapt(data)}}
                                </label>
                              </template>
                               {{ sportAllBetLang['ALL_BET.AND']}} {{ sportAllBetLang['ALL_BET.LBL_NO']}}
                            </template>
                            <template v-else-if="data.tbet == 'ab'">
                              {{ sportAllBetLang['ALL_BET.LBL_UNDER'] }} 
                              <template v-if="!chkIsBetting(data)"> {{ getHdpCapt(data)}} </template>
                              <template v-else>
                                <label class="yb-number-bold handicap" :class="{'bet-handicap':data.hdpChg}">
                                  {{ getHdpCapt(data)}}
                                </label>
                              </template>
                               {{ sportAllBetLang['ALL_BET.AND']}} {{ sportAllBetLang['ALL_BET.LBL_NO']}}
                            </template>
                          </template>
                          <template v-else>
                            {{ data.tbetcapt }}
                          </template>
                          <template v-if='data.betType=="1" || data.betType=="2" || data.betType=="8" || data.betType=="9" || data.betType=="46" || data.betType=="47" || data.betType=="48" || data.betType=="49" || data.betType=="63" || data.betType=="64" || data.betType=="68" || data.betType=="69" || data.betType=="80" || data.betType=="81" || data.betType=="82" || data.betType=="83"'>
                            <label class="handicap yb-number-bold bet-text-nowrap" :class="{'bet-handicap':data.hdpChg}" v-if="(data.hdp!=0 )">{{ getHdpCapt(data)}}</label>
                            <label class="handicap yb-number-bold bet-text-nowrap" :class="{'bet-handicap':data.hdpChg}" v-else-if="(data.hdp==0 && (data.betType == '1' ||data.betType == '8'))">0</label>
                          </template>
                        </label>
                      </div>
                    </div>
                    <div class="vrow">
                      <div class="col yb-fontsize16 bet-odds-value">
                        <span class="odds-value yb-number-bold">
                          <span>@</span>
                          <template v-if="data.betType == 7 || data.betType == 16">
                            {{ new Number(parseFloat(data.odd)) }}
                          </template>
                          <template v-else>
                            <template v-if="betting.success">
                              {{ getDecimalDisplay(betting.success.data.betting[key].odd, betting.success.data.betting[key].sprtid) }}
                            </template>
                            <template v-else>
                              {{ getDecimalDisplay(data.odd, data.sprtid) }}
                            </template>
                          </template>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>

            <!-- <div class="bet-mix-result-card q-card q-card--flat no-shadow bet-mix-record-result-last">
              <div class="q-card__section q-card__section--vert bet-success-bg">
                <div class="odds-wrap vrow">
                  <div class="line"></div>
                  <div class="col bet-play-info yb-fontsize13">{{betLang["BETTING.LBL_PARLAY_"+betAllUp]}}</div>
                  <div class="col-auto bet-icon-info">
                    <i data-v-082e727f="" aria-hidden="true" role="presentation" class="q-icon icon-success c-icon" style="font-size: 18px;"></i>
                  </div>
                </div>
                <div class="vrow bet-win-info">
                  <div class="col yb-fontsize12"> {{ betLang['BETTING.LBL_STAKE'] }} </div>
                  <div class="col-auto yb-fontsize12"> {{ sportAllBetLang["ALL_BET.HIGH_WIN"] }} </div>
                </div>
                <div class="vrow bet-win-info2 yb-fontsize12">
                  <div class="col bet-win-value">{{ betting.success.data.betAmt | decimal(2) }}</div>
                  <div class="col-auto bet-win-value text-right yb-fontsize12">{{ betSuccessPPayout(null, betting.selectedBetAllup) | decimal(2) }}</div>
                </div>
              </div>
            </div> -->
            <template v-if="(betting.success && betting.success.data.mulpRes) || (betting.pending && betting.pending.data.mulpRes)">
              <template v-for="(data, key) in ((betting.success && betting.success.data.mulpRes) || (betting.pending && betting.pending.data.mulpRes))">
                <div class="bet-mix-result-card q-card q-card--flat no-shadow bet-mix-record-result-last">
                  <div class="q-card__section q-card__section--vert bet-success-bg">
                    <div class="odds-wrap vrow">
                      <div class="line"></div>
                      <div class="col bet-play-info yb-fontsize13">{{ getMulpCaption(betLang, data.allUp) }}</div>
                      <div class="col-auto bet-icon-info" style="display:block!important;">
                        <template v-if="data.wgStatus && data.wgStatus == '1'">
                          <span id="dg_icon" class="pending_wager"></span>
                        </template>
                        <template v-else>
                          <i aria-hidden="true" role="presentation" class="q-icon c-icon" :class="{'icon-failure':data.WagerID==undefined, 'icon-success':data.WagerID!=undefined}" style="font-size: 18px;"></i>
                        </template>
                      </div>
                    </div>
                    <div class="vrow bet-win-info">
                      <div class="col yb-fontsize12"> {{ betLang['BETTING.LBL_STAKE'] }} </div>
                      <div class="col-auto yb-fontsize12"> {{ sportAllBetLang["ALL_BET.HIGH_WIN"] }} </div>
                    </div>
                    <div class="vrow bet-win-info2 yb-fontsize12">
                      <div class="col bet-win-value">{{ data.amount? data.amount:betMulpAmtFiltered[key].stake | decimal(2) }}</div>
                      <div class="col-auto bet-win-value text-right yb-fontsize12">{{ betMulpAmtFiltered[key].possiblePayout | decimal(2) }}</div>
                    </div>
                  </div>
                </div>
                <div v-if="data.error!=undefined && data.error!=''" class="bet-confirm-message text-center yb-fontsize12 bet-fail-order" style="margin-left: 5px; margin-right: 5px; background: rgba(255, 64, 64, 0.2); color: #ff4040; border-radius: 0px 0px 6px 6px;">
                  {{ data.error.message }}<br>{{ data.error.code }}
                </div>
              </template>
            </template>
            <div class="bet-mix-result-card q-card q-card--flat no-shadow bet-mix-record-result-last">
              <div class="q-card__section q-card__section--vert bet-success-bg">
                <div class="vrow bet-total" style="line-height: 24px;">
                  <!-- <div class="col bet-total-left">{{ betLang["BETTING.LBL_TOTAL_BET"] }} 1</div> -->
                  <div class="col bet-total-left">{{ betLang["BETTING.LBL_TOTAL_BET"] }} {{ countTotalStakePayout('totalBet', true) }}</div>
                  <!-- <div class="col-auto bet-total-right">{{ totalStake | decimal(2) }}</div> -->
                  <div class="col-auto bet-total-right">{{ countTotalStakePayout('totalStake', true) | decimal(2) }}</div>
                </div>
                <div class="vrow bet-total" style="line-height: 24px;">
                  <div class="col bet-total-left">{{ betLang["BETTING.LBL_EST_WIN"] }}
                    <!-- 预计总收益  -->
                  </div>
                  <!-- <div class="col-auto bet-total-right bet-gold-text">{{ possiblePayout | decimal(2) }}</div> -->
                  <div class="col-auto bet-total-right bet-gold-text">{{ countTotalStakePayout('possiblePayout', true) | decimal(2) }}</div>
                </div>
              </div>
            </div>
          </div>
        
          <div class="c-bet-mix-info" id="cbetmixinfo" v-if="!betting.success && !betting.pending">
            <!-- Bet Info -->
            <template v-for="(data, key) in betFormList" v-if="betFormList"> 
              <div class="relative-position bet-mix-item-card q-card q-card--flat no-shadow" 
              :class="{'bet-mix-item-first':key==0, 'bet-no-effect':(betting.minMax==undefined || Object.keys(betFormList).length < betting.minMax.minCombo || (data.error && data.error!=''))}">
                <div class="q-card__section q-card__section--vert">
                  <div class="vrow">
                    <div class="col bet-league-name">{{data.league}}</div>
                    <div class="col-auto" @click="deleteMatch(data.eventObj.eveid, data)">
                      <i aria-hidden="true" role="presentation" class="bet-del q-icon icon-del c-icon" style="font-size: 12px;"></i>
                    </div>
                  </div>
                  <div class="vrow">
                    <div class="col bet-against">
                      <span class="home-vs-away"><span v-html="data.ta"></span><span class="bet-pk">v</span><span v-html="data.tb"></span></span> 
                      <span v-if="data.eventObj && data.eventObj.rbinfo">({{data.eventObj.rbinfo.scoa}}-{{data.eventObj.rbinfo.scob}})</span>
                    </div>
                  </div>
                  <div class="bet-content">
                    <div class="vrow">
                      <div class="col bet-play-game">
                        <label class="bet-play-text">
                          <label class="bet-match-playing" v-if="data.eventObj && data.eventObj.rbstatus">{{ sportAllBetLang["ALL_BET.LBL_LIVE"] }}</label>
                          {{ getPtBtCapt(data)}}
                          <label class="bet-handicap-name">{{getOddsTypeCap(data)}} </label>
                        </label>
                      </div>
                    </div>
                    <div class="vrow no-wrap">
                      <div class="col bet-play-team">
                        <label class="bet-team-handicap">
                          <template v-if="data.betType == '2' || data.betType == '9' || data.betType == '46' || data.betType == '47' || data.betType == '48' || data.betType == '49' || data.betType=='80' || data.betType=='81' || data.betType=='82' || data.betType=='83'">
                            <template v-if="data.tbet == 'a'">
                              {{ sportAllBetLang["ALL_BET.LBL_OVER"] }}
                            </template>
                            <template v-else-if="data.tbet == 'b'">
                              {{ sportAllBetLang["ALL_BET.LBL_UNDER"] }}
                            </template>
                          </template>
                          <template v-else-if="data.betType == '32' || data.betType == '33' || data.betType == '76' || data.betType == '79'">
                            <template v-if="data.tbet == 'a'">
                              {{ sportAllBetLang["ALL_BET.LBL_YES"] }}
                            </template>
                            <template v-else-if="data.tbet == 'b'">
                              {{ sportAllBetLang["ALL_BET.LBL_NO"] }}
                            </template>
                          </template>
                          <template v-else-if="data.betType == '21' || data.betType == '27' || data.betType == '36' || data.betType == '37' || data.betType == '38' || data.betType == '39' || data.betType == '40' || data.betType == '41' || data.betType == '42' || data.betType == '43' || data.betType == '44' || data.betType == '45'">
                            <template v-if="data.tbet == 'a'">
                              {{ sportAllBetLang["ALL_BET.LBL_HOME"] }} 
                            </template>
                            <template v-else-if="data.tbet == 'b'">
                              {{ sportAllBetLang["ALL_BET.LBL_AWAY"] }}
                            </template>
                            <template v-else-if="data.tbet == 'x'">
                              {{ sportAllBetLang["ALL_BET.LBL_DRAW"] }}
                            </template>
                            <template v-if="data.betType == '21' || data.betType == '27'">
                              ({{ h1x2Header(data.hdp, data.tbet) }})
                            </template>
                          </template>
                          <template v-else-if="data.betType == '50' || data.betType == '51'">
                            <template v-if="data.tbet == 'h1'">
                              {{ sportAllBetLang["ALL_BET.LBL_HWB1"] }}
                            </template>
                            <template v-else-if="data.tbet == 'h2'">
                              {{ sportAllBetLang["ALL_BET.LBL_HWB2"] }}
                            </template>
                            <template v-else-if="data.tbet == 'h3'">
                              {{ sportAllBetLang["ALL_BET.LBL_HWB3"] }}
                            </template>
                            <template v-else-if="data.tbet == 'h4'">
                              {{ sportAllBetLang["ALL_BET.LBL_HWB4M"] }}
                            </template>
                            <template v-else-if="data.tbet == 'a1'">
                              {{ sportAllBetLang["ALL_BET.LBL_AWB1"] }}
                            </template>
                            <template v-else-if="data.tbet == 'a2'">
                              {{ sportAllBetLang["ALL_BET.LBL_AWB2"] }}
                            </template>
                            <template v-else-if="data.tbet == 'a3'">
                              {{ sportAllBetLang["ALL_BET.LBL_AWB3"] }}
                            </template>
                            <template v-else-if="data.tbet == 'a4'">
                              {{ sportAllBetLang["ALL_BET.LBL_AWB4M"] }}
                            </template>
                            <template v-else-if="data.tbet == 'sd'">
                              {{ sportAllBetLang["ALL_BET.LBL_AS"] }}
                            </template>
                            <template v-else-if="data.tbet == 'ng'">
                              {{ sportAllBetLang["ALL_BET.LBL_NG"] }}
                            </template>
                          </template>
                          
                          <template v-else-if="data.betType == '77' || data.betType == '78'">
                            <template v-if="data.tbet == 'h1'">
                              {{ sportAllBetLang["ALL_BET.LBL_HWB1R"] }}
                            </template>
                            <template v-else-if="data.tbet == 'h2'">
                              {{ sportAllBetLang["ALL_BET.LBL_HWB2R"] }}
                            </template>
                            <template v-else-if="data.tbet == 'h3'">
                              {{ sportAllBetLang["ALL_BET.LBL_HWB3R"] }}
                            </template>
                            <template v-else-if="data.tbet == 'h4'">
                              {{ sportAllBetLang["ALL_BET.LBL_HWB4RM"] }}
                            </template>
                            <template v-else-if="data.tbet == 'a1'">
                              {{ sportAllBetLang["ALL_BET.LBL_AWB1R"] }}
                            </template>
                            <template v-else-if="data.tbet == 'a2'">
                              {{ sportAllBetLang["ALL_BET.LBL_AWB2R"] }}
                            </template>
                            <template v-else-if="data.tbet == 'a3'">
                              {{ sportAllBetLang["ALL_BET.LBL_AWB3R"] }}
                            </template>
                            <template v-else-if="data.tbet == 'a4'">
                              {{ sportAllBetLang["ALL_BET.LBL_AWB4RM"] }}
                            </template>
                            <template v-else-if="data.tbet == 'sd'">
                              {{ sportAllBetLang["ALL_BET.LBL_BB_AS"] }}
                            </template>
                            <template v-else-if="data.tbet == 'ng'">
                              {{ sportAllBetLang["ALL_BET.LBL_NG"] }}
                            </template>
                          </template>
                          <template v-else-if="data.betType == '28' || data.betType == '29' || data.betType == '30' || data.betType == '31'">
                            <template v-if="data.tbet == 'a'">
                              {{ sportAllBetLang["ALL_BET.LBL_1HT"] }}
                            </template>
                            <template v-else-if="data.tbet == 'b'">
                              {{ sportAllBetLang["ALL_BET.LBL_2HT"] }}
                            </template>
                            <template v-else-if="data.tbet == 'x'">
                              {{ sportAllBetLang["ALL_BET.LBL_DRAW"] }}
                            </template>
                          </template>
                          <template v-else-if="data.betType == '25'">
                            <template v-if="data.tbet == 'h_1_5'">
                              {{ sportAllBetLang['ALL_BET.LBL_HOME'] }} {{ sportAllBetLang["ALL_BET.LBL_WIN_BY_1T5"] }}
                            </template>
                            <template v-else-if="data.tbet == 'h_6_10'">
                              {{ sportAllBetLang['ALL_BET.LBL_HOME'] }} {{ sportAllBetLang["ALL_BET.LBL_WIN_BY_6T10"] }}
                            </template>
                            <template v-else-if="data.tbet == 'h_11_15'">
                              {{ sportAllBetLang['ALL_BET.LBL_HOME'] }} {{ sportAllBetLang["ALL_BET.LBL_WIN_BY_11T15"] }}
                            </template>
                            <template v-else-if="data.tbet == 'h_16_20'">
                              {{ sportAllBetLang['ALL_BET.LBL_HOME'] }} {{ sportAllBetLang["ALL_BET.LBL_WIN_BY_16T20"] }}
                            </template>
                            <template v-else-if="data.tbet == 'h_21_25'">
                              {{ sportAllBetLang['ALL_BET.LBL_HOME'] }} {{ sportAllBetLang["ALL_BET.LBL_WIN_BY_21T25"] }}
                            </template>
                            <template v-else-if="data.tbet == 'h_26_x'">
                              {{ sportAllBetLang['ALL_BET.LBL_HOME'] }} {{ modifyTitle('h_26_x') }}
                            </template>
                            <template v-else-if="data.tbet == 'a_1_5'">
                              {{ sportAllBetLang['ALL_BET.LBL_AWAY'] }} {{ sportAllBetLang["ALL_BET.LBL_WIN_BY_1T5"] }}
                            </template>
                            <template v-else-if="data.tbet == 'a_6_10'">
                              {{ sportAllBetLang['ALL_BET.LBL_AWAY'] }} {{ sportAllBetLang["ALL_BET.LBL_WIN_BY_6T10"] }}
                            </template>
                            <template v-else-if="data.tbet == 'a_11_15'">
                              {{ sportAllBetLang['ALL_BET.LBL_AWAY'] }} {{ sportAllBetLang["ALL_BET.LBL_WIN_BY_11T15"] }}
                            </template>
                            <template v-else-if="data.tbet == 'a_16_20'">
                              {{ sportAllBetLang['ALL_BET.LBL_AWAY'] }} {{ sportAllBetLang["ALL_BET.LBL_WIN_BY_16T20"] }}
                            </template>
                            <template v-else-if="data.tbet == 'a_21_25'">
                              {{ sportAllBetLang['ALL_BET.LBL_AWAY'] }} {{ sportAllBetLang["ALL_BET.LBL_WIN_BY_21T25"] }}
                            </template>
                            <template v-else-if="data.tbet == 'a_26_x'">
                              {{ sportAllBetLang['ALL_BET.LBL_AWAY'] }} {{ modifyTitle('a_26_x') }}
                            </template>
                          </template>
                          <template v-else-if="data.betType == '52'">
                            <template v-if="data.tbet == 'hf'">
                              {{ sportAllBetLang["ALL_BET.LBL_HFG"] }}
                            </template>
                            <template v-else-if="data.tbet == 'hl'">
                              {{ sportAllBetLang["ALL_BET.LBL_HLG"] }}
                            </template>
                            <template v-else-if="data.tbet == 'af'">
                              {{ sportAllBetLang["ALL_BET.LBL_AFG"] }}
                            </template>
                            <template v-else-if="data.tbet == 'al'">
                              {{ sportAllBetLang["ALL_BET.LBL_ALG"] }}
                            </template>
                            <template v-else-if="data.tbet == 'ng'">
                              {{ sportAllBetLang["ALL_BET.LBL_NG"] }}
                            </template>
                          </template>
                          <template v-else-if="data.betType == '53' || data.betType == '54' || data.betType == '55' || data.betType == '56'">
                            <template v-if="data.tbet == '0_5'">
                              {{ sportAllBetLang["ALL_BET.LBL_05"] }}
                            </template>
                            <template v-else-if="data.tbet == '1_6'">
                              {{ sportAllBetLang["ALL_BET.LBL_16"] }}
                            </template>
                            <template v-else-if="data.tbet == '2_7'">
                              {{ sportAllBetLang["ALL_BET.LBL_27"] }}
                            </template>
                            <template v-else-if="data.tbet == '3_8'">
                              {{ sportAllBetLang["ALL_BET.LBL_38"] }}
                            </template>
                            <template v-else-if="data.tbet == '4_9'">
                              {{ sportAllBetLang["ALL_BET.LBL_49"] }}
                            </template>
                          </template>
                          <template v-else-if="data.betType == '19' || data.betType == '20'">
                            <template v-if="data.tbet == 'ha'">
                              {{ sportAllBetLang["ALL_BET.LBL_HOME_OR_AWAY"] }}
                            </template>
                            <template v-else-if="data.tbet == 'hd'">
                              {{ sportAllBetLang["ALL_BET.LBL_HOME_OR_DRAW"] }}
                            </template>
                            <template v-else>
                              {{ sportAllBetLang["ALL_BET.LBL_AWAY_OR_DRAW"] }}
                            </template>
                          </template>
                          <template v-else-if="data.betType == '57' || data.betType == '58'">
                            <template v-if="data.tbet == 'ng0'">
                              {{ sportAllBetLang["ALL_BET.LBL_0"] }}
                            </template>
                            <template v-else-if="data.tbet == 'ng1'">
                              {{ sportAllBetLang["ALL_BET.LBL_1"] }}
                            </template>
                            <template v-else-if="data.tbet == 'ng2'">
                              {{ sportAllBetLang["ALL_BET.LBL_2"] }}
                            </template>
                            <template v-else-if="data.tbet == 'ng3'">
                              {{ sportAllBetLang["ALL_BET.LBL_3"] }}
                            </template>
                            <template v-else-if="data.tbet == 'ng4'">
                              {{ sportAllBetLang["ALL_BET.LBL_4"] }}
                            </template>
                            <template v-else-if="data.tbet == 'ng5'">
                              {{ sportAllBetLang["ALL_BET.LBL_5"] }}
                            </template>
                            <template v-else-if="data.tbet == 'ng6'">
                              {{ sportAllBetLang["ALL_BET.LBL_6more"] }}
                            </template>
                          </template>
                          <template v-else-if="data.betType == '59' || data.betType == '73'">
                            <template v-if="data.tbet == 'ha'">
                              {{ sportAllBetLang['ALL_BET.LBL_OVER'] }} 
                              <template v-if="!chkIsBetting(data)"> {{ getHdpCapt(data)}} </template>
                              <template v-else>
                                <label class="yb-number-bold handicap" :class="{'bet-handicap':data.hdpChg}">
                                  {{ getHdpCapt(data)}}
                                </label>
                              </template>
                               {{ sportAllBetLang['ALL_BET.AND']}} {{ sportAllBetLang['ALL_BET.LBL_ODD']}}
                            </template>
                            <template v-else-if="data.tbet == 'hb'">
                              {{ sportAllBetLang['ALL_BET.LBL_OVER'] }} 
                              <template v-if="!chkIsBetting(data)"> {{ getHdpCapt(data)}} </template>
                              <template v-else>
                                <label class="yb-number-bold handicap" :class="{'bet-handicap':data.hdpChg}">
                                  {{ getHdpCapt(data)}}
                                </label>
                              </template>
                               {{ sportAllBetLang['ALL_BET.AND']}} {{ sportAllBetLang['ALL_BET.LBL_EVEN']}}
                            </template>
                            <template v-else-if="data.tbet == 'aa'">
                              {{ sportAllBetLang['ALL_BET.LBL_UNDER'] }} 
                              <template v-if="!chkIsBetting(data)"> {{ getHdpCapt(data)}} </template>
                              <template v-else>
                                <label class="yb-number-bold handicap" :class="{'bet-handicap':data.hdpChg}">
                                  {{ getHdpCapt(data)}}
                                </label>
                              </template>
                               {{ sportAllBetLang['ALL_BET.AND']}} {{ sportAllBetLang['ALL_BET.LBL_ODD']}}
                            </template>
                            <template v-else-if="data.tbet == 'ab'">
                              {{ sportAllBetLang['ALL_BET.LBL_UNDER'] }} 
                              <template v-if="!chkIsBetting(data)"> {{ getHdpCapt(data)}} </template>
                              <template v-else>
                                <label class="yb-number-bold handicap" :class="{'bet-handicap':data.hdpChg}">
                                  {{ getHdpCapt(data)}}
                                </label>
                              </template>
                               {{ sportAllBetLang['ALL_BET.AND']}} {{ sportAllBetLang['ALL_BET.LBL_EVEN']}}
                            </template>
                          </template>
                          <template v-else-if="data.betType == '60' || data.betType == '61'">
                            <template v-if="data.tbet == 'ha'">
                              {{ sportAllBetLang['ALL_BET.LBL_OVER'] }} 
                              <template v-if="!chkIsBetting(data)"> {{ getHdpCapt(data)}} </template>
                              <template v-else>
                                <label class="yb-number-bold handicap" :class="{'bet-handicap':data.hdpChg}">
                                  {{ getHdpCapt(data)}}
                                </label>
                              </template>
                               {{ sportAllBetLang['ALL_BET.AND']}} {{ sportAllBetLang['ALL_BET.LBL_YES']}}
                            </template>
                            <template v-else-if="data.tbet == 'hb'">
                              {{ sportAllBetLang['ALL_BET.LBL_UNDER'] }} 
                              <template v-if="!chkIsBetting(data)"> {{ getHdpCapt(data)}} </template>
                              <template v-else>
                                <label class="yb-number-bold handicap" :class="{'bet-handicap':data.hdpChg}">
                                  {{ getHdpCapt(data)}}
                                </label>
                              </template>
                               {{ sportAllBetLang['ALL_BET.AND']}} {{ sportAllBetLang['ALL_BET.LBL_YES']}}
                            </template>
                            <template v-else-if="data.tbet == 'aa'">
                              {{ sportAllBetLang['ALL_BET.LBL_OVER'] }} 
                              <template v-if="!chkIsBetting(data)"> {{ getHdpCapt(data)}} </template>
                              <template v-else>
                                <label class="yb-number-bold handicap" :class="{'bet-handicap':data.hdpChg}">
                                  {{ getHdpCapt(data)}}
                                </label>
                              </template>
                               {{ sportAllBetLang['ALL_BET.AND']}} {{ sportAllBetLang['ALL_BET.LBL_NO']}}
                            </template>
                            <template v-else-if="data.tbet == 'ab'">
                              {{ sportAllBetLang['ALL_BET.LBL_UNDER'] }} 
                              <template v-if="!chkIsBetting(data)"> {{ getHdpCapt(data)}} </template>
                              <template v-else>
                                <label class="yb-number-bold handicap" :class="{'bet-handicap':data.hdpChg}">
                                  {{ getHdpCapt(data)}}
                                </label>
                              </template>
                               {{ sportAllBetLang['ALL_BET.AND']}} {{ sportAllBetLang['ALL_BET.LBL_NO']}}
                            </template>
                          </template>
                          <template v-else>
                            {{ data.tbetcapt }}
                          </template>
                          <template v-if='data.betType=="1" || data.betType=="2" || data.betType=="8" || data.betType=="9" || data.betType=="46" || data.betType=="47" || data.betType=="48" || data.betType=="49" || data.betType=="63" || data.betType=="64" || data.betType=="68" || data.betType=="69" || data.betType=="80" || data.betType=="81" || data.betType=="82" || data.betType=="83"'>
                            <label class="handicap yb-number-bold bet-text-nowrap" :class="{'bet-handicap':data.hdpChg}" v-if="(data.hdp!=0 )">{{ getHdpCapt(data)}}</label>
                            <label class="handicap yb-number-bold bet-text-nowrap" :class="{'bet-handicap':data.hdpChg}" v-else-if="(data.hdp==0 && (data.betType == '1' ||data.betType == '8'))">0</label>
                          </template>
                        </label>
                      </div>
                    </div>
                    <div class="vrow">
                      <div class="col bet-odds-value" :class="getOddChange(data)">
                        <span class="odds-value yb-number-bold">
                          <span>@</span>
                          <template v-if="data.betType == 7 || data.betType == 16">
                            {{ new Number(parseFloat(data.odd)) }}
                          </template>
                          <template v-else>
                            {{ getDecimalDisplay(data.odd, data.sprtid) }}
                          </template>
                        </span>
                      </div>
                      <div class="auto-col">
                        <template v-if="betting.error && data.error && data.error!=''">
                          <span class="invalid serial-msg" v-if="data.error.code && (data.error.code.indexOf('4000-N1') > -1 || data.error.code.indexOf('4031') > -1)">{{ betLang["BETTING.NOT_SUPPORT_PARLAY"] }}</span>
                          <span class="invalid serial-msg" v-else>{{ sportAllBetLang["ALL_BET.BET_CLOSE"] }}</span>
                        </template>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>

            <!-- <div v-if="Object.keys(betFormList).length >= betting.minMax.minCombo && !betting.success" class="bet-mix-input-card q-card q-card--flat no-shadow bet-mix-input-last" id="betmixcard">
              <div class="q-card__section q-card__section--vert">
                <div class="odds-wrap vrow">
                  <div class="line"></div>
                  <div class="col bet-mix-info">
                    <template v-if="selectedLang==2 || selectedLang==3">
                      {{ betLang["BETTING.LBL_PARLAY"] }} {{ betLang['BETTING.LBL_ALLUP'] }} :
                    </template>
                    <template v-else>
                      {{ betLang["BETTING.LBL_PARLAY"] }} :
                    </template>
                  </div>
                  <div class="r-select">
                    <div class="e-select relative-position down" :class="{'down':!showMULPopt,'up':showMULPopt}">
                      <div class="select-value ellipsis" @click="toggleMULPopt()">{{ getMulpCaption(betLang, betAllUp) }}</div>
                      <div v-if="showMULPopt" class="options-wrap">
                        <div class="rule-scroll-area q-scrollarea" style="height: 100%;">
                          <div class="q-scrollarea__container scroll relative-position fit hide-scrollbar" style="min-height:100% !important">
                            <div class="q-scrollarea__content absolute">
                              <template v-for="allUp in betting.allUpList">
                                <p class="item ellipsis" :class="{'active':betAllUp==allUp.key}" @click="selAllUp(allUp.key)">{{ getMulpCaption(betLang, allUp.key) }}</p>
                              </template>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="odds-wrap vrow">
                  <div class="col bet-mix-info" style="padding-left:0px;height:auto !important" v-html="allupBetting(betAllUp,betLang,selectedLang)"></div>
                </div>
              </div>
            </div>
            <div v-if="Object.keys(betFormList).length >= betting.minMax.minCombo && !betting.success" id="bet_input_defaut_one">
              <div class="bet-mix-input-card bet-input q-card q-card--flat no-shadow" style="padding-top: 0px;">
                <div class="q-card__section q-card__section--vert">
                  <div data-check-money="0" class="vrow bet-mix-input">
                    <input inputmode="decimal" 
                        :placeholder="betMinMaxVal" 
                        autocomplete="off"
                        onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                        class="bet-input input-border" 
                        :class="JSErr" 
                        size="8"
                        maxlength="10"
                        ref="betAmount" 
                        v-model="betAmount"
                        @keydown.enter.prevent="confirmBetForm" />
                    <div class="bet-max-btn" style="top:20px;">X{{ totalBet }}</div> 
                    <div :class="{'bet-input-close-1':totalBet.toString().length==1,'bet-input-close-2':totalBet.toString().length>1}" style="top:13px;" @click="clearInput()" v-if="betAmount.length>0">
                      <i aria-hidden="true" role="presentation" class="q-icon icon-failure c-icon" style="font-size: 12px;"></i>
                    </div>
                  </div>
                  <div class="vrow bet-win yb-fontsize12">
                    <div class="col df-jb">{{ sportAllBetLang["ALL_BET.HIGH_WIN"] }}</div>
                    <div class="col-auto bet-win-money yb-number-bold">{{ possiblePayout | decimal(2) }}</div>
                  </div>
                  <div class="bet-keyboard-zone q-card__section q-card__section--vert">
                    <div class="vrow bet-keyboard bet-keyboard-content">
                      <div class="col">
                        <div class="q-gutter-xs keyboard-zone">
                          <div class="keyboard-btn" @click="addsum(betting.betAmountOption.min)">
                            <div class="keyboard-btn-text">+{{ betting.betAmountOption.min }}</div>
                          </div>
                          <div class="keyboard-btn" @click="addsum(betting.betAmountOption.med)">
                            <div class="keyboard-btn-text">+{{ betting.betAmountOption.med }}</div>
                          </div>
                          <div class="keyboard-btn" @click="addsum(betting.betAmountOption.big)">
                            <div class="keyboard-btn-text">+{{ betting.betAmountOption.big }}</div>
                          </div>
                          <div class="keyboard-btn" @click="addsum(betting.betAmountOption.big2)">
                            <div class="keyboard-btn-text">+{{ betting.betAmountOption.big2 }}</div>
                          </div>
                          <div class="keyboard-btn" @click="addsum(betting.betAmountOption.big3)">
                            <div class="keyboard-btn-text">+{{ commasAmount(betting.betAmountOption.big3) }}</div>
                          </div>
                          <div class="keyboard-btn" @click="addsum(betting.betAmountOption.max)">
                            <div class="keyboard-btn-text">{{ langList.sportMinibetLang['SPORT_MINIBET.MAX'] }}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div> -->
            <div v-if="betMulpAmount && betMulpAmount.length>0 && betting.allUpList && betting.minMax && Object.keys(betFormList).length >= betting.minMax.minCombo && !betting.error" id="bet_input_defaut_one">
              <div class="bet-mix-input-card q-card q-card--flat no-shadow bet-mix-input-last" :id="'betmixcard_'+betting.allUpList[0].key">
                <div class="q-card__section q-card__section--vert">
                  <div class="odds-wrap vrow">
                    <div class="line"></div>
                    <div class="col bet-mix-info">
                      {{ getMulpCaption(betLang, betting.allUpList[0].key) }}
                    </div>
                    <span class="odds-value yb-number-bold">@{{ getMULPOdds() }}</span>
                  </div>
                  <template v-if="checkMaxOdds(0)">
                  <div data-check-money="0" class="vrow bet-mix-input">
                    <input inputmode="decimal" 
                        :placeholder="betMinMaxMulp(0)" 
                        autocomplete="off"
                        onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                        :id="betting.allUpList[0].key"
                        class="bet-input input-border" 
                        :class="JSErr" 
                        size="8"
                        :maxlength="amountMaxLength"
                        ref="betAmount0"
                        v-model="betMulpAmount[0].value"
                        v-on:input="setbetMulpKeyboard(0)"
                        @keydown.enter.prevent="confirmBetForm"
                        @focus="showKeyboard(betting.allUpList[0].key, 0)" />
                    <!-- <div class="bet-max-btn" style="top:47px;">X{{ totalBet1(betting.allUpList[0].key) }}</div>  -->
                    <div :class="{'bet-input-close-1':totalBet1(betting.allUpList[0].key).toString().length==1,'bet-input-close-2':totalBet1(betting.allUpList[0].key).toString().length>1}" style="top:40px; right: 10px;" @click="clearInput(0)" v-if="Object.keys(betMulpAmount[0].value).length>0">
                      <i aria-hidden="true" role="presentation" class="q-icon icon-failure c-icon" style="font-size: 12px;"></i>
                    </div>
                  </div>
                  <div class="mulp_keyboard" :class="betting.allUpList[0].key">
                    <div class="vrow bet-win yb-fontsize12">
                      <div class="col df-jb">{{ sportAllBetLang["ALL_BET.HIGH_WIN"] }}</div>
                      <div class="col-auto bet-win-money yb-number-bold">{{ displayMulpPossiblePayout(0) | decimal(2) }}</div>
                    </div>
                    <div class="bet-keyboard-zone q-card__section q-card__section--vert">
                      <div class="vrow bet-keyboard bet-keyboard-content">
                        <div class="col">
                          <div class="q-gutter-xs keyboard-zone">
                            <div class="keyboard-btn" :class="{' disable-key-btn': checkAllowKeyboard(null, keyboardAllow.min, 0, 'min')}" @click="addsum(betting.betAmountOption.min, 0)">
                              <div class="keyboard-btn-text">+{{ betting.betAmountOption.min }}</div>
                            </div>
                            <div class="keyboard-btn" :class="{' disable-key-btn': checkAllowKeyboard(null, keyboardAllow.med, 0, 'med')}" @click="addsum(betting.betAmountOption.med, 0)">
                              <div class="keyboard-btn-text">+{{ betting.betAmountOption.med }}</div>
                            </div>
                            <div class="keyboard-btn" :class="{' disable-key-btn': checkAllowKeyboard(null, keyboardAllow.big, 0, 'big')}" @click="addsum(betting.betAmountOption.big, 0)">
                              <div class="keyboard-btn-text">+{{ betting.betAmountOption.big }}</div>
                            </div>
                            <div class="keyboard-btn" :class="{' disable-key-btn': checkAllowKeyboard(null, keyboardAllow.big2, 0, 'big2')}" @click="addsum(betting.betAmountOption.big2, 0)">
                              <div class="keyboard-btn-text">+{{ betting.betAmountOption.big2 }}</div>
                            </div>
                            <div class="keyboard-btn" :class="{' disable-key-btn': checkAllowKeyboard(null, keyboardAllow.big3, 0, 'big3')}" @click="addsum(betting.betAmountOption.big3, 0)">
                              <div class="keyboard-btn-text">+{{ commasAmount(betting.betAmountOption.big3) }}</div>
                            </div>
                            <div class="keyboard-btn" :class="{' disable-key-btn': checkAllowKeyboard(null, keyboardAllow.big3, 0, 'big3')||betMulpAmount[0].maxPay==''||betMulpAmount[0].maxPay==0}" @click="MaxAmt(betMulpAmount[0].maxPay, 0)">
                              <div class="keyboard-btn-text">{{ langList.sportMinibetLang['SPORT_MINIBET.MAX'] }}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  
                </template>
                <template v-else>
                  <div data-v-9f62b2ae="" class="bet-message text-center" style="height: auto; line-height: normal; margin: 15px 0px;color:#ff4040;">
                    {{ betLang['BETTING.EXCEED_MAX_ODDS']+' '+betting.minMax.maxOdds }}
                  </div>
                </template>
                </div>
              </div>
            </div>
            <template v-if="betMulpAmount && betMulpAmount.length>0 && betting.allUpList && betting.allUpList.length>1 && betting.minMax && Object.keys(betFormList).length >= betting.minMax.minCombo && !betting.error">
              <div class="row bet-toggle bet-toggle-up" @click="multipleBetClick()">
                <div class="col bet-toggle-text cursor-pointer">{{ betLang['BETTING.LBL_MULTIPLE_BET'] }}</div>
                <div class="col-auto">
                  <span class="">
                    <i aria-hidden="true" role="presentation" class="q-icon icon-triangle c-icon icon-pull-down" :class="{'icon-pull-up':multipleBetToggle}" style="font-size: 16px;"></i>
                  </span>
                </div>
              </div>
              <div style="" v-if="multipleBetToggle">
                <template v-for="(allUp, index) in betting.allUpList" v-if="index>=1">
                  <div class="bet-mix-input-card q-card q-card--flat no-shadow bet-mix-input-last" :id="'betmixcard_'+allUp.key">
                    <div class="q-card__section q-card__section--vert">
                      <div class="odds-wrap vrow">
                        <div class="line"></div>
                        <div class="col bet-mix-info">
                          {{ getMulpCaption(betLang, allUp.key) }}
                        </div>
                      </div>
                      <template v-if="checkMaxOdds(index)">
                        <div data-check-money="0" class="vrow bet-mix-input">
                          <input inputmode="decimal" 
                              :placeholder="betMinMaxMulp(index)" 
                              autocomplete="off"
                              onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                              :id="allUp.key"
                              class="bet-input input-border" 
                              :class="JSErr" 
                              size="8"
                              :maxlength="amountMaxLength"
                              :ref="'betAmount'+index"
                              v-model="betMulpAmount[index].value"
                              v-on:input="setbetMulpKeyboard(index)"
                              @keydown.enter.prevent="confirmBetForm"
                              @focus="showKeyboard(allUp.key, index)" />
                          <!-- <div class="bet-max-btn" style="top:47px;">X{{ totalBet1(allUp.key) }}</div>  -->
                          <div :class="{'bet-input-close-1':totalBet1(allUp.key).toString().length==1,'bet-input-close-2':totalBet1(allUp.key).toString().length>1}" style="top:40px; right: 10px;" @click="clearInput(index)" v-if="Object.keys(betMulpAmount[index].value).length>0">
                            <i aria-hidden="true" role="presentation" class="q-icon icon-failure c-icon" style="font-size: 12px;"></i>
                          </div>
                        </div>
                      
                        <div class="mulp_keyboard" :class="allUp.key" style="display:none;">
                          <div class="vrow bet-win yb-fontsize12">
                            <div class="col df-jb">{{ sportAllBetLang["ALL_BET.HIGH_WIN"] }}</div>
                            <div class="col-auto bet-win-money yb-number-bold">{{ displayMulpPossiblePayout(index) | decimal(2) }}</div>
                          </div>
                          <div class="bet-keyboard-zone q-card__section q-card__section--vert">
                            <div class="vrow bet-keyboard bet-keyboard-content">
                              <div class="col">
                                <div class="q-gutter-xs keyboard-zone">
                                  <div class="keyboard-btn" :class="{' disable-key-btn': checkAllowKeyboard(null, keyboardAllow.min, index, 'min')}" @click="addsum(betting.betAmountOption.min, index)">
                                    <div class="keyboard-btn-text">+{{ betting.betAmountOption.min }}</div>
                                  </div>
                                  <div class="keyboard-btn" :class="{' disable-key-btn': checkAllowKeyboard(null, keyboardAllow.med, index, 'med')}" @click="addsum(betting.betAmountOption.med, index)">
                                    <div class="keyboard-btn-text">+{{ betting.betAmountOption.med }}</div>
                                  </div>
                                  <div class="keyboard-btn" :class="{' disable-key-btn': checkAllowKeyboard(null, keyboardAllow.big, index, 'big')}" @click="addsum(betting.betAmountOption.big, index)">
                                    <div class="keyboard-btn-text">+{{ betting.betAmountOption.big }}</div>
                                  </div>
                                  <div class="keyboard-btn" :class="{' disable-key-btn': checkAllowKeyboard(null, keyboardAllow.big2, index, 'big2')}" @click="addsum(betting.betAmountOption.big2, index)">
                                    <div class="keyboard-btn-text">+{{ betting.betAmountOption.big2 }}</div>
                                  </div>
                                  <div class="keyboard-btn" :class="{' disable-key-btn': checkAllowKeyboard(null, keyboardAllow.big3, index, 'big3')}" @click="addsum(betting.betAmountOption.big3, index)">
                                    <div class="keyboard-btn-text">+{{ commasAmount(betting.betAmountOption.big3) }}</div>
                                  </div>
                                  <div class="keyboard-btn" :class="{' disable-key-btn': checkAllowKeyboard(null, keyboardAllow.big3, index, 'big3')||betMulpAmount[index].maxPay==''||betMulpAmount[index].maxPay==0}" @click="MaxAmt(betMulpAmount[index].maxPay, index)">
                                    <div class="keyboard-btn-text">{{ langList.sportMinibetLang['SPORT_MINIBET.MAX'] }}</div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </template>
                      <template v-else>
                        <div data-v-9f62b2ae="" class="bet-message text-center" style="height: auto; line-height: normal; margin: 15px 0px;color:#ff4040;">
                          {{ betLang['BETTING.EXCEED_MAX_ODDS']+' '+betting.minMax.maxOdds }}
                        </div>
                      </template>
                    </div>
                  </div>
                </template>
              </div>
            </template>
          </div>

          <div style="display: none;"></div>
        </div>
      </div>
    </div>
    <!-- END Mulp -->

    <div v-if="((oddSelected || betting.success||betting.betcombosuccess||betting.pending||betting.reject||betting.betcomboerror) && openBetForm && isUsingPhone() === 1)" id="scrollFooterPhone" class="scroll-footer-phone" style="bottom: auto;padding-bottom:70px">
      <bettingFormFooter></bettingFormFooter>
    </div>
  </div>
</template>

<script>
import EventBus from "@/vue/events/event-bus";
import vueCookie from 'vue-cookie'
import accounting from "accounting";
import allBetMixin from "@/vue/mixins/allBet";
import sportFavourite from '@/vue/mixins/favourite'
import moment from "moment";
import bettingFormFooter from './bettingFormFooter'
// import VueFilterNumber from "@/vue/filters/vue-filter-number";
// import forecastCalculationMixin from '@/vue/mixins/forecastCalculation'
// import forecast from '@/vue/components/forecast'

import { mapGetters } from "vuex";
export default {
  components: {
    bettingFormFooter
  },
  mixins: [allBetMixin,sportFavourite],
  computed: {
    ...mapGetters([
      "oddSelected",
      "BetTypeLang",
      "selectedMarket",
      "selectedBettype",
      "selectedSport",
      "betting",
      "requestAllow",
      "account",
      'isBetSuccess',
      'isProcessBet',
      'isPlacedBet',
      'pendingFlag',
      'hdpDisp',
      'mulpSetting',
      'jsError',
      // 'forecast',
      'sportForecastToggle',
      'oddTypesList',
      'isBetCombo',
      'betComboAmount',
      'betCombo_jsError',
      'openBetForm',
      'promotionFlag',
      'promotionBetStatus',
      'betMulpAmount',
      'betMulpAmtFiltered',
      'isParlayTab',
      'selectedMulpBetBoxId',
    ]),
    selectedMarket() {
      return this.$store.getters.selectedMarket;
    },
    betAmount: {
      get() {
        // var fixedAccountingNumber = accounting.toFixed(this.$store.getters.sportMiniBet.betAmount, 0);
        var fixedAccountingNumber = parseInt(this.$store.getters.sportMiniBet.betAmount);
        var res = this.$store.getters.sportMiniBet.betAmount == 0 ? "" : this.commasAmount(fixedAccountingNumber);

        if(this.selectedBettype.betTypId != "5" && this.$store.getters.account.rememberStake && vueCookie.get(this.$store.getters.account.acccode + '_stakeSetting') && this.$store.getters.sportMiniBet.betAmount==0){
          var b = JSON.parse(vueCookie.get(this.$store.getters.account.acccode + '_stakeSetting'))
          var bamt = accounting.toFixed(b.stkAmt, 0)
          res = (bamt==0)? '' : this.commasAmount(bamt);

          this.betAmount = res
          this.possiblePayout
          if (this.$refs.betAmount && this.$refs.betAmount.length>0) {
            // if(this.selectedBettype.betTypId == "5"){
            //   this.$refs.betAmount.focus();
            // }else{
              this.$refs.betAmount[0].focus();
            // }
          }
        }

        return res
      },
      set(value) {
        var fixedAccountingNumber = accounting.toFixed(value, 0);
        //cannot exceed current CL
        if(this.$store.getters.account.currCL < parseInt(fixedAccountingNumber)){
          fixedAccountingNumber = this.$store.getters.account.currCL
          // this.JSErr = ''
        }
        // for indo odds when odds less than 0 , bet amount should be ccl / odds
        if(this.$store.getters.account.oddsType == 'in' && this.$store.getters.betForm[0].odd <= 0){
          var maxAccNum = parseInt(parseInt(this.$store.getters.account.currCL) / Math.abs(this.$store.getters.betForm[0].odd))
          if(fixedAccountingNumber > maxAccNum){
            fixedAccountingNumber = maxAccNum
          }
        }
        this.$store.commit("SPORT_MINIBET_BETAMOUNT", fixedAccountingNumber);

        var b = ''
        if(vueCookie.get(this.$store.getters.account.acccode + '_stakeSetting')){
          b = JSON.parse(vueCookie.get(this.$store.getters.account.acccode + '_stakeSetting'))
        }
        if(b=='' || (b && (b.rmbStk!=value || b.stkAmt!=this.$store.getters.sportMiniBet.betAmount))){
          this.usualStakeAmount = fixedAccountingNumber //set rmb stake amount
        }
        this.JSErr = ''

        var remainingBal = this.$store.getters.account.currCL - parseInt(fixedAccountingNumber)
        // cause indo odds when odds less than 0 , bet amount should be ccl / odds , so remain balance need to check it
        if(this.$store.getters.account.oddsType == 'in' && this.$store.getters.betForm[0].odd <= 0){
          remainingBal = parseInt(parseInt(this.$store.getters.account.currCL) - (parseInt(fixedAccountingNumber) * Math.abs(this.$store.getters.betForm[0].odd)))
        }
        this.setKeyboardSettings('-1', remainingBal)

        if(value != fixedAccountingNumber) {
          this.betAmount = fixedAccountingNumber
        }
      },
    },
    betComboAmount: {
      get(){
        let betAmountArr = this.$store.getters.betComboAmount

        if(this.selectedBettype.betTypId != "5" && this.$store.getters.account.rememberStake 
        && vueCookie.get(this.$store.getters.account.acccode + '_stakeSetting') 
        && this.betFormList.length==1){
          var b = JSON.parse(vueCookie.get(this.$store.getters.account.acccode + '_stakeSetting'))
          var bamt = accounting.toFixed(b.stkAmt, 0)
          var res = (bamt==0)? '' : this.commasAmount(bamt);
          betAmountArr[0].value = res
        }

        return betAmountArr
      },
      set(arr){
        this.$store.commit("BETCOMBO_AMOUNT", arr);
        this.JSErr = ''

        //BetCombo single has remember stake
        if (this.selectedBettype.betTypId != "5" && this.$store.getters.account.rememberStake 
        && vueCookie.get(this.$store.getters.account.acccode + '_stakeSetting')
        && this.betFormList.length==1){
          var b = ''
          b = JSON.parse(vueCookie.get(this.$store.getters.account.acccode + '_stakeSetting'))
          if (b=='' || (b && b.stkAmt!=parseInt(arr.amount))){
            this.usualStakeAmount = arr.amount //set rmb stake amount
          }
        }
        
      }
    },
    betComboKeyboardAllow: {
      get(){
        let betComboKeyboardArr = this.$store.getters.betComboKeyboardAllow
        return betComboKeyboardArr
      },
      set(arr){
        this.$store.commit("BETCOMBO_KEYBOARDALLOW", arr);
      }
    },
    usualStakeAmount: {
      get() {
        // return this.$store.getters.account.usualStakeAmount;
      },
      set(value) {
        var b = ''
        if(vueCookie.get(this.$store.getters.account.acccode + '_stakeSetting')){
          b = JSON.parse(vueCookie.get(this.$store.getters.account.acccode + '_stakeSetting'))
        }
        if(b && parseInt(value) != b.stkAmt){
          var stkset = {
            rmbStk: b.rmbStk,
            stkAmt: value,
          }
          $.ajax({
            method: 'post',
            url: _baseUrl + '/callCookies', 
            data: {
              action: 'rememberStk',
              stkSetting: JSON.stringify(stkset),
              acc_code: this.$store.getters.account.acccode
            },
          }).done((res) => {
            //console.log('r: '+res)
          })
        }
      },
    },
    betAllUp: {
      get() {
        if(this.isMulp && this.$store.getters.betting.selectedBetAllup!=null){
          var totalBetSlip = this.$store.getters.betting.selectedBetAllup.split('x')
          if(this.$store.getters.betAmount && this.$store.getters.betAmount>0){
            this.totalStake = this.$store.getters.betAmount * totalBetSlip[1];
          }else{
            this.totalStake =0;
          }
          
          this.totalBet=totalBetSlip[1];
        }
        return this.$store.getters.betting.selectedBetAllup;
      },
      set(value) {
        this.$store.commit("BETTING_ALLUP", value);
      },
    },
    possiblePayout() {
      var oddValue = "";
      if (this.isMulp) {
        var amount = 0;

        var allUpIndex = _.findIndex(this.betting.allUpList, {
          key: this.$store.getters.betting.selectedBetAllup,
        });
        var mulpParser = this.betting.allUpList[allUpIndex].parser.split("#");
        for (let index = 0; index < mulpParser.length; index++) {
          const commaList = mulpParser[index].split(",");
          var ttlOdds = 1;
          oddValue = "";
          for (let comma = 0; comma < commaList.length; comma++) {
            const betData = this.$store.getters.betForm[commaList[comma]];
            var betOdd = parseFloat(betData.odd);
            if(this.$store.getters.account.oddsType=='am'){
              if(betOdd<0){
                betOdd=Math.abs(100/betOdd)+1;
              }else{
                betOdd= (betOdd / 100)+1;
              }
             //alert(betOdd)
              betOdd= betOdd.toFixed(3);
            }
            ttlOdds *= betOdd;
          }
          oddValue = ttlOdds - 1;
          amount += this.betAmount * oddValue;
          // amount += this.$store.getters.sportMiniBet.betAmount * oddValue;
        }

        return amount;
      } else {
        var betOdd = parseFloat(this.$store.getters.betForm[0].odd);
        oddValue =
          (betOdd < 0 && (this.$store.getters.account.oddsType=='my' || this.$store.getters.account.oddsType=='in'))
            ? 1
            : this.validateOddBetType(
                this.$store.getters.betForm[0].betType,
                this.$store.getters.betForm[0].odd
              );
      }
      // return this.$store.getters.betAmount * oddValue;
      return this.$store.getters.sportMiniBet.betAmount * oddValue;
    },
    betFormList: function() {
      return this.$store.getters.betForm
    },
    isBetCombo: {
      get() {
        return this.$store.getters.isBetCombo;
      },
      set(value) {
        var bet = this.betting

        if(!value && this.betFormList.length>1 && !bet.pending && !bet.success){
          this.$store.dispatch("removeMatch", {
            data: {clearType: '2'}, //remove All Match But Last
            callback: (() => {
              // document.getElementById(event.uniqueId).parentElement.classList.remove('active')
              this.$store.dispatch("getBettingInfo", {
                callback: ((res) => {
                  this.$store.commit("IS_BETCOMBO", value);
                  this.$store.commit("SPORT_MAPPING_BETTING", {
                    newBettingList: res.SYSTEM_DATA.betting,
                    oldBettingList: this.$store.getters.betForm,
                  });
                  // this.betFormHeight()
                  this.refreshTimer();
                  this.isReloading = false;
                }).bind(this),
              });
            }).bind(this),
          });
        } else if (!bet.pending && !bet.success) {
          this.$store.dispatch("getBettingInfo", {
            isBetCombo: value,
            callback: ((res) => {
              this.$store.commit("IS_BETCOMBO", value);
              
              this.$store.commit("SPORT_MAPPING_BETTING", {
                newBettingList: res.SYSTEM_DATA.betting,
                oldBettingList: this.$store.getters.betForm,
              });

              //single betcombo
              if(this.$store.getters.isBetCombo &&this.betFormList.length==1){
                let singleBetAmount = this.$store.getters.sportMiniBet.betAmount
                let betAmountArr = this.$store.getters.betComboAmount
                if(singleBetAmount!='' && singleBetAmount!='0'){
                  var arr = { index: 0, amount: singleBetAmount }
                  this.betComboAmount = arr
                }

                // disable keyboard amount if balance didnt meet the amount

                if (this.$store.getters.betComboAmount[0].value != ''){
                  var amt = this.$store.getters.betComboAmount[0].value
                  var betAmt = (amt!='' || amt!=0) ? parseInt(amt.replace(",", "")) : 0
                  var remainingBal = this.$store.getters.account.currCL - betAmt
                  this.setKeyboardSettings(0, remainingBal)
                }
              } else {
                let betAmountArr = this.$store.getters.betComboAmount[0].value
                var fixedAccountingNumber = accounting.toFixed(betAmountArr, 0);
                this.$store.commit("SPORT_MINIBET_BETAMOUNT", fixedAccountingNumber);
                if (fixedAccountingNumber!= ''){
                  var amt = fixedAccountingNumber
                  var betAmt = (amt!='' || amt!=0) ? parseInt(amt.replace(",", "")) : 0
                  var remainingBal = this.$store.getters.account.currCL - betAmt
                  this.setKeyboardSettings('-1', remainingBal)
                }
              }

              this.refreshTimer();
              this.isReloading = false;
            }).bind(this),
          });
        } else {
          this.$store.commit("IS_BETCOMBO", value);
        }
      },
    },
    betMulpAmount: {
      get(){
        let betMulpArr = this.$store.getters.betMulpAmount
        return betMulpArr
      },
      set(arr){
        if(!_.isUndefined(arr.index) && !_.isUndefined(arr.allUp) && !_.isUndefined(arr.amount)){
          // calculate the possible payout and stake for current mulp
          arr = this.mulpPossiblePayout(arr)
          this.$store.commit("BETMULP_AMOUNT", arr);
          this.JSErr = ''
          
          // calculate the total stake for all mulp
          var ttlMulpAmt = this.countTotalStakePayout('totalStake');
          var currCL = parseInt(this.$store.getters.account.currCL)

          //cannot exceed current CL
          if(currCL < ttlMulpAmt){
            // calculate amount user can bet for current mulp
            var allUpKey = this.$store.getters.betMulpAmount[arr.index].allUp
            var totalBetSlip = allUpKey.split('x')
            var remainingAmt = currCL - (ttlMulpAmt - Number(this.$store.getters.betMulpAmount[arr.index].stake==''?0:this.$store.getters.betMulpAmount[arr.index].stake.replaceAll(",", "")))
            if(remainingAmt>=0){
              arr.amount = Math.floor(remainingAmt / parseInt(totalBetSlip[1]))
            } else {
              arr.amount = ''
            }
            arr = this.mulpPossiblePayout(arr)
            this.$store.commit("BETMULP_AMOUNT", arr);
            // calculate the total stake for all mulp
            ttlMulpAmt = this.countTotalStakePayout('totalStake');
          }

          var remainingBal = currCL - parseInt(ttlMulpAmt)
          this.setKeyboardSettings('-1', remainingBal)
        }
      }
    },
  },
  props: {

  },
  data() {
    return {
      isNegative: false,
      isDiff: false,
      isMulp: false,
      timerSeconds: 10,
      fixTimer: 10,
      timerId: null,
      pendingTimerId: null,
      isReloading: false,
      isJustRecheck: false,
      isFirstLoad: true,
      selectedLang: window._langid,
      wagerId: null,
      pendingWager: {
        data: null,
        status: false,
      },
      isMulpDayExceed: false,
      totalStake: 0,
      totalBet: 0,
      langList: window.lang,
      betMinMaxVal: '',
      JSErr: '',
      odChgClass: '',
      hoverInfo: false,
      showMULPopt: false,
      multipleBetToggle: true,
      mulpOdds: 0,
      amountMaxLength: window.amountMaxLength,
    };
  },
  watch: {
    betFormList: {
      handler: function(val, oldVal) {
        this.isMulpDayExceed = false;

        //this.$store.getters.betting.success || this.$store.getters.betting.betcombosuccess || 
        if(this.$store.getters.betting.pending){
          var pendingWagerIds = (this.$store.getters.isBetCombo) ? _.map( _.filter(val, { wgStatus: '1' }) , 'WagerID') : [this.$store.getters.betting.pending.data.WagerID]
          if(this.isMulp) {
            pendingWagerIds = []
            _.forEach(this.$store.getters.betting.pending.data.mulpRes, (function(value, key) {
                pendingWagerIds.push(value.WagerID)
            }).bind(this));
          }
          this.checkPendingWager(pendingWagerIds)
        }

        if (val.length > 0 && !this.$store.getters.sportMiniBet.toggle) {
          this.$nextTick(() => {
            // if (this.$refs.betAmount && this.$refs.betAmount.length>0) {
            //   if(this.selectedBettype.betTypId == "5" || this.$store.getters.isBetCombo){
            //     this.$refs.betAmount.focus();
            //   }else{
            //     this.$refs.betAmount[0].focus();
            //   }
            // }
            if(this.$store.getters.isBetCombo){
              if(this.betFormList.length>1){
                if (this.$refs.betAmount) {
                  this.$refs.betAmount.focus();
                }
              } else {
                if(this.$refs.betAmount0 && this.$refs.betAmount0.length>0){
                  this.$refs.betAmount0[0].focus();
                }
              }
            } else if(this.selectedBettype.betTypId == "5"){
              if(this.betting && this.betting.minMax && this.betFormList.length>=this.betting.minMax.minCombo){
                if ($('.bet-input')[this.selectedMulpBetBoxId]!=undefined) {
                  $('.bet-input')[this.selectedMulpBetBoxId].focus();
                }
                // if (this.$refs['betAmount'+this.selectedMulpBetBoxId]!=undefined) {
                //   if(this.$refs['betAmount'+this.selectedMulpBetBoxId].length>0){
                //     this.$refs['betAmount'+this.selectedMulpBetBoxId][0].focus();
                  // } else {
                  //   this.$refs['betAmount'+this.selectedMulpBetBoxId].focus();
                //   }
                // }
              }
            } else {
              if (this.$refs.betAmount && this.$refs.betAmount.length>0) {
                this.$refs.betAmount[0].focus();
              }
            }
          });
        }
        if(!this.betting.error){
          this.betMinMax()
        }
        if (this.selectedBettype.betTypId == "5" || this.$store.getters.isBetParlay) { //mulp
          var smallDate = null;
          var bigDate = null;
          _.forEach(
            val,
            ((value) => {
              if(value.oddChg==true || value.hdpChg==true){
                this.$store.commit("BETMULP_AMOUNT", {clear: true})
              }

              var eventDate = "";
              if (value.eventObj && value.eventObj.dt) {
                var onlyDate = new moment(value.eventObj.dt).format(
                  "YYYY-MM-DD 00:00:00"
                );
                eventDate = new moment(onlyDate);
              }
              if(eventDate!="") {
                if (smallDate == null && bigDate == null) {
                  smallDate = eventDate;
                  bigDate = eventDate;
                }
                //smallDate > eventDate
                if (smallDate.diff(eventDate, "days") > 0) {
                  smallDate = eventDate;
                } else if (eventDate.diff(bigDate, "days") > 0) {
                  bigDate = eventDate;
                }

                if (bigDate.diff(smallDate, "days") >= 7) {
                  this.isMulpDayExceed = true;
                }
              }
            }).bind(this)
          );
          this.isMulp = true;

          // if(Object.keys(this.betFormList).length >= this.$store.getters.betting.minMax.minCombo){
          //   this.selAllUp(this.betAllUp, '1')
          // }
          
        } else {
          this.isMulp = false;
        }

        this.$nextTick(() => {
          $('#singleContainer').css({height: 'auto'})
          var screenHeight = $(window).height();
          var topY;
          if(this.isUsingPhone() === 0){
            var scrFooter = document.getElementById('scrollFooter');
            if(this.$store.getters.isBetCombo && this.$store.getters.betForm.length>1){  
              scrFooter.style.position = 'absolute'
              scrFooter.style.bottom = 0
              scrFooter.style.top = null
            } else{
              if(this.selectedBettype.betTypId == "5"){
                if (this.$store.getters.betForm.length > 2) {
                  topY = $('#normalScroll').height();
                } else if (this.$store.getters.betForm.length == 1) {
                  topY = $('#scrollHeaderX').height() + $('#normal-middle-content').height();
                } else if (this.$store.getters.betForm.length == 2) {
                  //to avoid mispositioning if screenHeight < 764 when bet 2 match in parlay
                  topY = (screenHeight <= 765) ? $('#mulpBetArea').height() : $('#scrollHeaderX').height() + $('#normal-middle-content').height();
                }
              } else {         
                if (screenHeight <= 765) {
                  //$('#normalScroll').height() - 10 is to eliminate a 10px gap
                  topY = (document.querySelector('.bet-confirm-message')) ? $('#normalScroll').height() - 10 : $('#normalScroll').height();
                } else {
                  topY = $('#normal-middle-content').height() + $('#scrollHeaderX').height();
                }
              }
              document.getElementById('scrollFooter').style.top = topY+'px';
            }
            $("#leftBarNormalScroll").getNiceScroll().resize();
          }
        });
      },
      deep: true,
      immediate: true,
    },
    jsError: {
      handler(value, oldVal) {
        if(value.error && value.errorId=='4'){
          this.JSErr = 'input-border-red'
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    handleResize() {
      $("#normalScroll").getNiceScroll().resize();
    },
    getOddChange(data){
      var sts = ''
      if(this.betting.success || this.betting.pending || this.betting.betcombosuccess && !_.isUndefined(data.error) && data.error!='' ) {
        return sts
      }

      if(data.oddChg && data.oddChgUpDown=='up' || (!_.isUndefined(data.error) && data.error!='' && data.oddChgUpDown=='up')){
        sts = 'up-red'
      } else if (data.oddChg && data.oddChgUpDown=='down' || (!_.isUndefined(data.error) && data.error!='' && data.oddChgUpDown=='down')) {
        sts = 'down-green'
      }
      return sts
    },
    getBetConfirmClass(data, key){
      if((data.hdpChg || data.oddChg) && _.isUndefined(data.wgStatus) && _.isUndefined(data.error) && data.error!=''){
        return ''
      }

      if(this.betting.success || (this.$store.getters.isBetCombo && this.wgSuccess.includes(data.wgStatus))){
        return 'bet-success-order'
      } else if (this.betting.pending && data.wgStatus==1){
        return 'bet-pending-order'
      } else {  //(isBetCombo && checkShowErrMsg(data, jsError))
        var singleLine = (this.jsError.error || !_.isUndefined(this.betCombo_jsError[key]) && this.betCombo_jsError[key].error) ? ' bet-js-error' : ''
        return 'bet-fail-order'+singleLine
      }
      hdpChg
    },
    checkShowErrMsg(data, jsErr, key){
      if(data.error || jsErr.error || data.oddChg || data.hdpChg || this.wgSts.includes(data.wgStatus) || (!_.isUndefined(this.betCombo_jsError[key]) && this.betCombo_jsError[key].error)){
        return true
      }
    },
    bettingResultClass(data, key){
      var index = key +1
      var b = (key!=0) ? ' mt5' : ''
      var last = (index == this.betFormList.length) ? ' last-item' : ''
      var err = (data.error || this.betting.error || data.wgStatus=='-1') ? ' bet-no-effect':''
      var single = (this.chkBettingSuccess(data) || this.chkBetPending(data)) ? ' bet-single-record ' : ''
      var res = (this.chkIsBetting(data)||this.chkBetPending(data)|| data.wgStatus=='-1') ? ' relative-position bet-card bet-single-item-card' : ''

      return err + single + last + res + b
    },
    chkIsBetting(data, where){
      // console.log('where : '+where)
      let isBC = this.$store.getters.isBetCombo
      let r = false
      if(isBC){ //betcombo
        if(_.isUndefined(data.WagerID) && $.inArray(data.wgStatus, ['0','1','-1','2']) < 0){ //&& _.isUndefined(data.error)
          r = true
        }
      } else {  //single
        if(!this.betting.success && _.isUndefined(data.wgStatus)){
          r = true
        }
      }
      return r
    },
    chkBettingSuccess(data, where){
      // console.log('where : '+where)
      let isBC = this.$store.getters.isBetCombo
      let r = false
      if(isBC){ //betcombo
        if(!_.isUndefined(data.WagerID) && _.isUndefined(data.error) && $.inArray(data.wgStatus, ['0','2']) > -1){
          r = true
        } else if (this.betting.success) {  //switch to betcombo when single success bet
          r = true
        }
      } else {  //single
        // if($.inArray(data.betType, this.rbBetTypeList) > -1 && data.wgStatus=='1'){
        //   r = true
        // }
        if(this.betting.success){
          r = true
        }
      }

      return r
    },
    chkBetPending(data, where){
      // console.log('where : '+where)
      let isBC = this.$store.getters.isBetCombo
      let r = false
      if(isBC){ //betcombo
        if(data.wgStatus=='1' && this.betting.pending){ //!_.isUndefined(data.WagerID) && 
          r = true
        }
      } else {  //single
        if($.inArray(data.betType, this.rbBetTypeList) > -1 && data.wgStatus=='1' && this.betting.pending){
          r = true
        }
      }

      return r
    },
    selAllUp(allupKey, action=null){
      var VUE = this
      var ttlBet = 0
      this.betAllUp = allupKey
      if(action==null && action!='1'){  //first load default allup changes, dont call toggle dropdownlist
        this.toggleMULPopt()
      }

      if(mulpSetting[VUE.betAllUp]){
        var ccBr=0;
        $.each(mulpSetting[VUE.betAllUp],function(listup, cbet){
          ttlBet += cbet
            // var ssAdd="";
            // if(selectedLang==1 && parseInt(cbet)>1){
            //   ssAdd="s";
            // }
            // if(betLang["BETTING.LBL_PARLAY_"+listup]){
            //   if(ccBr!=0) str+= "<br>";
            //   str+= " > "+betLang["BETTING.LBL_PARLAY_"+listup] +" ("+cbet+" "+betLang["BETTING.LBL_PARLAY_BET"] +ssAdd+")";
            //   ccBr=1;
            // }
        });
        this.totalBet = ttlBet
      }
      
      // this.$nextTick(() => {
      //   this.betFormHeight()
      // });
    },
    toggleMULPopt(){
      this.showMULPopt = !this.showMULPopt
    },
    getMulpCaption(betLang, allup){
        let Mchar =allup.split("x");
        if(Mchar[1]=='1'){
            return betLang["BETTING.LBL_PARLAY_"+allup]+" X 1";
        }else{
          if(mulpSetting[allup]){
            if(Object.keys(mulpSetting[allup]).length>0){
                var ccBr=0;
                var countMBet=0;
                var lastKey="";
                $.each(mulpSetting[allup],function(listup,cbet){
                    ccBr+=1;
                    countMBet+=cbet;
                    lastKey=listup
                });
                if(ccBr==1){
                    if(lastKey!=""){
                        return betLang["BETTING.LBL_PARLAY_"+lastKey]+" X "+countMBet;
                    }
                }else{
                    var cap = betLang["BETTING.LBL_YANKEE"];
                    if(ccBr>2){
                        cap = betLang["BETTING.LBL_SUPER_YANKEE"];
                    }

                    if(cap=="Super Yankee" || cap=="Yankee"){
                        return cap+" X "+countMBet;
                    }else{
                        return Mchar[0]+cap+countMBet+" X "+countMBet;
                    }
                }
            }
          }
        }
        return allup;
    },
    getHdpCapt(data){
      if(data.hdp==0 && (data.betType == '1' || data.betType == '8')){
        return '0'
      }
      var str = ''
      if(data.fav == data.tbet){
        if(data.betType=='1' || data.betType=='8'){
          str = '-'
        }
      }else{
        if(data.betType=='1' || data.betType=='8'){
          str = '+'
        }  
      }
      var strCap = (!_.isUndefined(data.hdpCap)) ? data.hdpCap : data.hdp
      // prevent double +/- symbol
      if(str!= '' && (strCap.toString()).indexOf(str) == 0) {
        str = ''
      }

      return str + strCap
    },
    betSuccessPPayout(dataArr, selectedBetAllup){
      var data = dataArr

      if(selectedBetAllup==null){  //!mulp
        
        if(this.$store.getters.isBetCombo){
          var betOdd = (data.odd) ? parseFloat(data.odd) : parseFloat(data.betting[0].odd); //handle switch to betcombo from single
          var betOdd2 = (data.odd) ? data.odd : data.betting[0].odd;
          var betType = (data.betType) ? data.betType : data.betting[0].betType;
          var oddValue =
            (betOdd < 0 && (this.$store.getters.account.oddsType=='my' || this.$store.getters.account.oddsType=='in'))
              ? 1 : this.validateOddBetType(betType, betOdd2);
          return data.betAmt * oddValue;
        } else {
          if(this.betting.success){
            data = this.betting.success.data
          } else if (this.betting.pending){
            data = this.betting.pending.data
          }
          var betOdd = parseFloat(data.betting[0].odd)
          var oddValue =
            (betOdd < 0 && (this.$store.getters.account.oddsType=='my' || this.$store.getters.account.oddsType=='in'))
              ? 1
              : this.validateOddBetType(
                  data.betting[0].betType,
                  data.betting[0].odd
                );
          return data.betAmt * oddValue;
        }
        
      } else {
        var amount = 0;

        var allUpIndex = _.findIndex(this.betting.allUpList, {
          key: this.$store.getters.betting.selectedBetAllup,
        });
        var mulpParser = this.betting.allUpList[allUpIndex].parser.split("#");
        for (let index = 0; index < mulpParser.length; index++) {
          const commaList = mulpParser[index].split(",");
          var ttlOdds = 1;
          oddValue = "";
          for (let comma = 0; comma < commaList.length; comma++) {
            const betData = this.$store.getters.betForm[commaList[comma]];
            var betOdd = parseFloat(betData.odd);
            if(this.$store.getters.account.oddsType=='am'){
              if(betOdd<0){
                betOdd=Math.abs(100/betOdd)+1;
              }else{
                betOdd= (betOdd / 100)+1;
              }
              betOdd= betOdd.toFixed(3);
            }
            ttlOdds *= betOdd;
          }
          oddValue = ttlOdds - 1;
          amount += this.$store.getters.sportMiniBet.betAmount * oddValue;
        }

        return amount;
      }
    },
    betMinMax() {
      this.betMinMaxVal = this.sportAllBetLang['ALL_BET.LIMITS'] +' '+ this.commasAmount(this.$store.getters.betting.minMax.min) + ' ~ ' + this.commasAmount(this.$store.getters.betting.minMax.max)
    },
    eventBetMinMax(data) {
      if(!_.isUndefined(data.minMax)){
        var a = this.sportAllBetLang['ALL_BET.LIMITS'] +' '+ this.commasAmount(data.minMax.min) + ' ~ ' + this.commasAmount(data.minMax.max)
        return a
      }
    },
    getOddsTypeCap(dt){
      let otype = this.$store.getters.account.oddsType
      var ot_cap = this.oddTypesList[otype.toUpperCase()].lang
      var btList = ['1','8','2','9','3','10','46','47','48','49','80','81','82','83']

      //OTR/MULP is either EURO odds or US odds only, double can be hk odds
      //dt.betType=='14' || 
      if(this.isMulp || $.inArray(dt.betType, btList) == -1){ 
        var str = (otype=='am') ? 'AM' : 'EU'
        ot_cap = this.oddTypesList[str].lang
      }

      if(dt.sprtid == '255') {
        var str = 'HK'
        if($.inArray(dt.betType, btList) == -1){
          str = 'EU'
        }
        ot_cap = this.oddTypesList[str].lang
      }

      return '['+ot_cap+']'
    },
    getPtBtCapt(dt){
      var space = (this.selectedLang==1) ? ' ' : ''
      var ptCapt = ''
      var btCapt = this.BetTypeLang[dt.betType]["caption"] 
      var homeAway = ''
      var res = ''

      // no need "(In-Play)"
      if(dt.betType == '8') { // hdp
        btCapt = this.BetTypeLang['1']["caption"]
      } else if(dt.betType == '27') { // 3 way
        btCapt = this.BetTypeLang['21']["caption"]
      } else if(dt.betType == '58') { // nog
        btCapt = this.BetTypeLang['57']["caption"]
      } else if(dt.betType == '64') { // 1x2 & ou
        btCapt = this.BetTypeLang['63']["caption"]
      } else if(dt.betType == '66') { // 1x2 & btts
        btCapt = this.BetTypeLang['65']["caption"]
      } else if(dt.betType == '73') { // ou & oe
        btCapt = this.BetTypeLang['59']["caption"]
      } else if(dt.betType == '61') { // ou & btts
        btCapt = this.BetTypeLang['60']["caption"]
      } else if(dt.betType == '69') { // dbch & ou
        btCapt = this.BetTypeLang['68']["caption"]
      } else if(dt.betType == '71') { // dbch & btts
        btCapt = this.BetTypeLang['70']["caption"]
      }

      if(dt.betType=='14'){ //outright
        res = btCapt
      }else{
        if (dt.plyType!='1'){
          //SC FT dont show FT caption
          ptCapt = this.langList.playTypeLang[dt.plyType]['caption'] +' - '
        }

        res = ptCapt + homeAway + space + btCapt
      }

      return res
    },
    getDecimalDisplay(value, sprtid) {
        if(this.$store.getters.account.oddsType=='am' && sprtid != 255){
          return Math.floor(parseFloat(value).toFixed(0));
        }
        return parseFloat(value).toFixed(2);
    },
    // convertDate(val) {
    //   return new moment(val).format("MM-DD");
    // },
    allupBetting(allup,betLang,selectedLang){
      var str="";
      if(mulpSetting[allup]){
        var ccBr=0;
        $.each(mulpSetting[allup],function(listup,cbet){
            var ssAdd="";
            if(selectedLang==1 && parseInt(cbet)>1){
              ssAdd="s";
            }
            if(betLang["BETTING.LBL_PARLAY_"+listup]){
              if(ccBr!=0) str+= "<br>";
              str+= " > "+betLang["BETTING.LBL_PARLAY_"+listup] +" ("+cbet+" "+betLang["BETTING.LBL_PARLAY_BET"] +ssAdd+")";
              ccBr=1;
            }
        });
      }
      return str;
    },
    allupCaption(allup,betLang,selectedLang){
      var str = betLang["BETTING.LBL_PARLAY_"+allup]
      return str;
    },
    addsum(amount, key=null){
      if(!this.$store.getters.isBetCombo && !this.isMulp){
        var amt = (this.$store.getters.sportMiniBet.betAmount=='') ? 0 : this.$store.getters.sportMiniBet.betAmount
        amount += Number(amt);

        //cannot exceed current CL
        if(this.$store.getters.account.currCL < amount){
          amount = this.$store.getters.account.currCL
        }
        this.betAmount = amount
        // this.$store.commit("SPORT_MINIBET_BETAMOUNT", amount);

      } else if (key!=null){
        var VUE = this
        if(this.$store.getters.isBetCombo){
          //betcombo individual add
          var amt = (_.isUndefined(VUE.betComboAmount[key])) ? 0 : VUE.betComboAmount[key].value.replace(",", "")
          amount += Number(amt);
          // var sum = accounting.toFixed(amount, 0)
          var arr = {
            index: key,
            amount: amount
          }
          VUE.betComboAmount = arr
          // this.$store.commit("BETCOMBO_AMOUNT", arr);
          
          var remainingBal = this.$store.getters.account.currCL - parseInt(amount)
          this.setKeyboardSettings(key, remainingBal)
        } else if(this.isMulp){
          var amt = (_.isUndefined(VUE.betMulpAmount[key])) ? 0 : VUE.betMulpAmount[key].value.replaceAll(",", "")
          amount += Number(amt);
          var arr = {
            index: key,
            allUp: VUE.betMulpAmount[key].allUp,
            amount: amount
          }
          VUE.betMulpAmount = arr

        }

      } else {
        //bet combo add all
        var VUE = this
        var amt = (VUE.allBetComboAmount=='') ? 0 : VUE.allBetComboAmount.replace(",", "")

        amount += Number(amt);
        var sum = accounting.toFixed(amount, 0)
        var total = sum
        VUE.allBetComboAmount = sum == 0 ? "" : this.commasAmount(sum)
        var rBal = VUE.$store.getters.account.currCL - parseInt(total.replace(",", ""))
        VUE.setKeyboardSettings('-1', rBal)

        var remainingBal = VUE.$store.getters.account.currCL
        $.each(VUE.betFormList, function(id, data){
          var arr = {
            index: id,
            amount: amount,
            clear: false
          }
          VUE.betComboAmount = arr

          remainingBal -= parseInt(VUE.$store.getters.betComboAmount[id].value.replace(",", ""))
          VUE.setKeyboardSettings(id, remainingBal)
        });
      }
      
    },
    MaxAmt(amount, key=null){
      var VUE = this
        if(this.$store.getters.isBetCombo){
          //betcombo individual add
          // var amt = (_.isUndefined(VUE.betComboAmount[key])) ? 0 : VUE.betComboAmount[key].value.replace(",", "")
          // amount += Number(amt);
          // var sum = accounting.toFixed(amount, 0)
          var arr = {
            index: key,
            amount: amount
          }
          VUE.betComboAmount = arr
          // this.$store.commit("BETCOMBO_AMOUNT", arr);
          
          var remainingBal = this.$store.getters.account.currCL - parseInt(amount)
          this.setKeyboardSettings(key, remainingBal)
        } else if(this.isMulp){
          // var amt = (_.isUndefined(VUE.betMulpAmount[key])) ? 0 : VUE.betMulpAmount[key].value.replaceAll(",", "")
          // amount += Number(amt);
          var arr = {
            index: key,
            allUp: VUE.betMulpAmount[key].allUp,
            amount: amount
          }
          VUE.betMulpAmount = arr

        }
    },
    checkOrder() {
      this.isJustRecheck = true;
      // if ($("#checkOrder").is(":checked")) {
        this.refreshTimer();
        this.startTimer();
      // } else {
      //   this.clearTimer();
      // }
    },
    onClickStartTimer() {
      if (!this.isJustRecheck) {
        this.isJustRecheck = false;
        this.timerSeconds = this.fixTimer;
        this.$store.dispatch("getBettingInfo", {
          token: token.arr_5,
          callback: ((res) => {
            this.$store.commit("SPORT_MAPPING_BETTING", {
              newBettingList: res.SYSTEM_DATA.betting,
              oldBettingList: this.$store.getters.betForm,
            });
            this.refreshTimer();
            this.isReloading = false;
          }).bind(this),
        });
      }
    },
    clearTimer() {
      // clearInterval(this.timerId);
      clearInterval(this.pendingTimerId);
      // this.timerId = null;
      this.pendingTimerId = null;
      // this.timerSeconds = this.fixTimer;
    },
    refreshTimer() {
      this.timerSeconds = this.fixTimer;
    },
    startTimer() {
      if (this.timerId == null) {
        this.timerId = setInterval(
          (() => {
            if (this.timerSeconds - 1 < 0) {
              this.timerSeconds = this.fixTimer;
              if (this.oddSelected && !this.isFirstLoad) {
                this.isReloading = true;
                this.$store.dispatch("getBettingInfo", {
                  token: token.arr_1,
                  callback: ((res) => {
                    this.$store.commit("SPORT_MAPPING_BETTING", {
                      newBettingList: res.SYSTEM_DATA.betting,
                      oldBettingList: this.$store.getters.betForm,
                    });
                    this.refreshTimer();
                    this.isReloading = false;
                  }).bind(this),
                });
              }
              this.isFirstLoad = false;
            } else {
              if (!this.isReloading) {
                this.timerSeconds -= 1;
              }
            }
          }).bind(this),
          1000
        );
      }
      return this.timerSeconds;
    },
    classNegative(odd) {
      return odd < 0 ? true : false;
    },
    cancelMiniBet() {
      this.$store.commit("SPORT_MINIBET_TOGGLE", false);
    },
    cancelBetForm() {
      this.cancelMiniBet();
      if (this.selectedBettype.betTypId == "5") {
        this.$store.commit("PARLAY_SELECTED", null);
      }
      this.$store.commit("BETTING_DELAY_TIMERID", null);
      this.$store.commit("REMOVE_MATCH", { removeAll: true });
      this.$store.commit("ODD_SELECTED", false);
      this.$store.commit("SELECTED_BETTAB", false);
      this.$store.commit("BETTING_MESSAGE", {
        isError: false,
      });
      this.$store.commit("JS_ERR", '');
    },
    diffOdds(val, oldVal) {
      this.isDiff = val != oldVal ? true : false;
    },
    deleteMatch(eventid, event, key) {
      // this.isProcessBet=true;
      // this.showProcessBet()

      if(!this.isProcessBet){
        if(this.$store.getters.isBetCombo){ //betcombo

          this.$store.dispatch("removeMatch", {
            data: {clearType: '3', index: key},
            callback: (() => {
              document.getElementById(event.uniqueId).parentElement.classList.remove('active')
              this.$store.commit("PARLAY_SELECTED", {
                remove: true,
                eveid: eventid,
              });
              if (this.betFormList.length <= 0) {
                this.$store.commit("OPEN_BETFORM", false)
                this.$store.commit('ODD_SELECTED', false)
                this.$store.commit("SHOW_BETFORM_MENU", false);
                this.$store.commit('SELECTED_TAB', 'betTab')
                return;
              }
              this.$store.dispatch("getBettingInfo", {
                callback: ((res) => {
                  this.$store.commit("SPORT_MAPPING_BETTING", {
                    newBettingList: res.SYSTEM_DATA.betting,
                    oldBettingList: this.$store.getters.betForm,
                  });
                  this.refreshTimer();
                  this.isReloading = false;
                }).bind(this),
              });
            }).bind(this),
          });
        } else { //single/mulp
          this.$store.dispatch("removeMatch", {
            data: {eveid: eventid},
            callback: (() => {
              document.getElementById(event.uniqueId).parentElement.classList.remove('active')
              this.$store.commit("PARLAY_SELECTED", {
                remove: true,
                eveid: eventid,
              });
              if (this.betFormList.length <= 0) {
                this.$store.commit("OPEN_BETFORM", false)
                this.$store.commit('ODD_SELECTED', false)
                this.$store.commit("SHOW_BETFORM_MENU", false);
                this.$store.commit('SELECTED_TAB', 'betTab')
                return;
              }
              this.$store.dispatch("getBettingInfo", {
                callback: ((res) => {
                  this.$store.commit("SPORT_MAPPING_BETTING", {
                    newBettingList: res.SYSTEM_DATA.betting,
                    oldBettingList: this.$store.getters.betForm,
                  });
                  this.refreshTimer();
                  this.isReloading = false;
                }).bind(this),
              });
            }).bind(this),
          });
        }
        
      }
    },
    checkPendingWager(pendingWagerIds) {
      let RBbtList = this.rbBetTypeList
      // let betSuccess = this.$store.getters.betting.success
      let VUE = this
      if(this.pendingTimerId == null){
        this.pendingTimerId = setInterval((() => {
          // if(this.waitingTimer - 1 < 0){
            // this.waitingTimer = this.fixTimer
            if(pendingWagerIds.length > 0) {
              this.$store.dispatch('getPendingWager', {
                'wagerIds': pendingWagerIds,
                'isParlay': VUE.isMulp? 1:0,
                'callback': (res) => {
                  if(res){
                    if(this.$store.getters.isBetCombo){

                    } else if(VUE.isMulp){
                      var pending_flag = false
                      var bettingData = VUE.betting.pending.data
                      _.forEach(res.wagerList.data, (function(value, key) {
                        var windex = _.findIndex(bettingData.mulpRes, { WagerID: value.wgNo })
                        if(windex > -1) {
                          bettingData.mulpRes[windex]['wgStatus'] = value.wgStatus
                        }
                        if(value.wgStatus == '1') {
                          pending_flag = true
                        }
                      }).bind(this));

                      if(pending_flag) {
                        this.$store.commit('BETTING_MESSAGE', {
                          isPending: true,
                          data: bettingData
                        })
                      } else {
                        this.$store.commit('BETTING_MESSAGE', {
                          isSuccess: true,
                          data: bettingData
                        })
                      }

                    } else {
                      var betData = res.wagerList.data[0]
                      
                      var rbconfirm = ($.inArray(betData.betTypId, RBbtList) > -1) ? '2' : '0'
                      var wgReject  = _.findIndex(res.wagerList.data, { wgStatus: '-1' }) //chk reject
                      var wgSuccess = _.findIndex(res.wagerList.data, { wgStatus: rbconfirm }) //chk success. 2:rb confirm, 0:confirm
                      
                      if(wgReject>-1){ //reject exist
                        this.$store.commit('BETTING_MESSAGE', {
                          isReject: true,
                          // data: ret.SYSTEM_DATA
                        })
                      } else if(wgSuccess>-1){ //success exist
                        this.$store.commit('BETTING_MESSAGE', {
                          isSuccess: true,
                          chkPendingSuccess: true,
                          data: VUE.betting.pending.data
                        })
                      }
                    }

                    this.$store.commit("SPORT_MAPPING_BETTING", {
                      newBettingList: res.wagerList.data,
                      oldBettingList: this.$store.getters.betForm,
                      chkPendingWager: 1,
                    });
                  }
                }
              })
            }
          // }else{
          //   this.waitingTimer -= 1
          // }
        }).bind(this),5000); //1000
      }
    },
    clearInput(key=null, mode=null) {
      if(key!=null){
        var arr = {
          index: key,
          amount: '',
          clear: false
        }
        if(this.$store.getters.isBetCombo){
          this.betComboAmount = arr
          var kdata = { index: key, settings: { min: true, med: true, big: true, big2: true, big3: true} }
          this.betComboKeyboardAllow = kdata
        } else if(this.isMulp) {
          arr.stake = ''
          arr.possiblePayout = ''
          arr.allUp =  this.$store.getters.betMulpAmount[key].allUp
          this.betMulpAmount = arr
          // this.resetKeyboardAllow()
          return
        }
      }else if(key==null && mode=='all'){ //clear all betcombo amount
        var VUE = this
        this.allBetComboAmount = ''

        var arr = { clear: true }
        VUE.betComboAmount = arr
        VUE.betComboKeyboardAllow = arr
        VUE.resetKeyboardAllow()
      } else {
        this.betAmount = ''
      }
      
      // this.$store.commit("SPORT_MINIBET_BETAMOUNT", 0);
      this.possiblePayout
    },
    showProcessBet() {
      if(!this.isProcessBet){
        var minMaxValidation = this.jsMinMaxValidation(
        this.$store.getters.betAmount,
          this.isMulp
        );
        if(minMaxValidation.error){
          // this.jsError = minMaxValidation;
          this.$store.commit('JS_ERR', minMaxValidation)
          // $('.hint').show();
          if(minMaxValidation.errorId==1){
             this.$store.getters.betAmount=Math.round(this.account.currCL);
          }else if(minMaxValidation.errorId==2){
              this.$store.getters.betAmount=Math.round(this.betting.minMax.min);
          }else if(minMaxValidation.errorId==3){
              this.$store.getters.betAmount=Math.round(this.betting.minMax.max);
          }
          var vue = this
          setTimeout(function() {
              // $('.hint').hide()
              vue.$store.commit('JS_ERR', '')
          }, 5000);
        }else{
          // $('.hint').hide();
          // this.jsError ="";
          this.$store.commit('JS_ERR', '')
          // $('#checkOrder').removeAttr('checked')
          this.checkOrder()
          if(this.betting.sErr){
            this.betting.sErr='';
          }
          this.$store.commit('PROCESS_BET', true)
          $('#submitBet').focus();
          // this.isProcessBet = true
          
        }
      }else if(this.isProcessBet){
        // $('#checkOrder').attr('checked', 'checked')
        this.checkOrder()
        this.$store.commit('PROCESS_BET', false)
        // this.isProcessBet = false
      }
    },
    checkError(errMsg) {
      if(errMsg){
        this.$store.commit('PLACED_BET', false)
        this.$store.commit('PROCESS_BET', false)
        return errMsg
      }
    },
    h1x2Header(hdp, team){
      if(team == 'a'){
        if(hdp > 0){
          return ' +' + parseInt(hdp)
        }else if(hdp < 0) {
          return parseInt(hdp)
        }
      }else if(team == 'b'){
        var nhdp = parseInt(hdp) * -1
        var ahdp = ''

        if(nhdp > 0){
          ahdp = '+' + nhdp
        }else if(nhdp < 0){
          ahdp = nhdp
        }

        return ahdp
      }else if(team == 'x'){
        if(hdp > 0){
          return this.sportAllBetLang['ALL_BET.LBL_HOME'] + ' +' + parseInt(hdp) 
        }else if(hdp < 0){
          var nhdp = parseInt(hdp) * -1
          var ahdp = ''

          if(nhdp > 0){
            ahdp = '+' + nhdp
          }else if(nhdp < 0){
            ahdp = nhdp
          }
          return this.sportAllBetLang['ALL_BET.LBL_AWAY'] + ' ' + ahdp
        }
      }
    },
    modifyTitle(odds){
      var title = this.sportAllBetLang["ALL_BET.LBL_WIN_BY_26MORE"]
      if(odds == 'h_26_x' || odds == 'a_26_x'){
        return title.replace('26','26+')
      }
    },
    resetKeyboardAllow(){
      this.keyboardAllow = {
        min: true,
        med: true,
        big: true,
        big2: true,
        big3: true,
      }
    },
    confirmBetForm(event) {
      let vue = this
      let errArr = []

      if(!this.$store.getters.isBetCombo){
        var minMaxValidation = this.jsMinMaxValidation(
          this.$store.getters.sportMiniBet.betAmount,
          this.isMulp
        );
      } else {
        // bet Combo
        let betAmountArr = this.$store.getters.betComboAmount
        var amt = ''
        var minMaxValidation = {}
        var ttlAmt = 0

        //Check each bet, betamount limit
        $.each(betAmountArr, function(id, data){
          amt = (data.value=='') ? 0 : data.value.replace(",", "")
          ttlAmt += parseInt(amt)
          var validation = vue.jsMinMaxValidation(amt, vue.isMulp);
          errArr[id] = { error: false }
          if(validation.error){
            minMaxValidation = validation
            errArr[id] = validation
          }
        });

        var minMaxValidationSUM = vue.jsMinMaxValidation(
          ttlAmt,
          vue.isMulp
        );
        if(minMaxValidationSUM.error){
          vue.$store.commit('JS_ERR', minMaxValidationSUM)
          setTimeout(function() {
            vue.$store.commit('JS_ERR', '')
          }, 5000);
          return
        }
      }
      
      if (!minMaxValidation.error) {
        this.$store.commit('PROCESS_BET', true)
        this.$store.dispatch("confirmBet", {
          callback: ((res) => {
            if(this.$store.getters.isBetCombo){
              this.betFormHeight()
            }
            this.$store.commit('PROCESS_BET', false)
            this.startTimer();
          }).bind(this),
        });
        this.$store.commit('PLACED_BET', true)

      } else {
        if(!this.$store.getters.isBetCombo){
          this.$store.commit('JS_ERR', minMaxValidation)

          if(minMaxValidation.errorId == 1){
            this.$store.getters.sportMiniBet.betAmount = Math.round(this.account.currCL);
          }else if(minMaxValidation.errorId == 2){
            this.$store.getters.sportMiniBet.betAmount = Math.round(this.betting.minMax.min);
          }else if(minMaxValidation.errorId == 3){
            this.$store.getters.sportMiniBet.betAmount = Math.round(this.betting.minMax.max);
          }
        } else { //bet combo
          this.$store.commit('BETCOMBO_JS_ERR', errArr)
          var a = ''
          let betAmountArr = this.$store.getters.betComboAmount
          $.each(betAmountArr, function(idx, val){
            if(errArr[idx] && errArr[idx].error){
              if(errArr[idx].errorId == 1){
                a = Math.round(vue.account.currCL);
              }else if(errArr[idx].errorId == 2){
                a = Math.round(vue.betting.minMax.min);
              }else if(errArr[idx].errorId == 3){
                a = Math.round(vue.betting.minMax.max);
              }
              var arr = { index: idx, amount: a, clear: false }
              vue.$store.commit("BETCOMBO_AMOUNT", arr);
            }
          });
        }

        setTimeout(function() {
          vue.$store.commit('JS_ERR', '')
          if(vue.$store.getters.isBetCombo){
            vue.$store.commit('BETCOMBO_JS_ERR', {})
          }
        }, 5000);
      }

    },
    isSportValidPromo(eventObj, bt){ // check if the bet got promotion
      var result = false;
      this.$store.dispatch("isSportValidPromo", {
        eventObj:eventObj,
        bt:bt,
        callback: ((res) => {
          result = res
        }).bind(this),
      });
      return result
    },
    checkMaxOdds(index){
      var ret = this.countMaxOdds(index)
      // if less than max odds (999) then will set the disable bet to be false
      if(ret == true){
        this.$store.commit('DISABLE_BET',false)
      }
      return ret
    }
  },
  mounted() {
    const element = document.querySelector("#leftBarNormalScroll");
    //detect #leftBarNormalScroll resize
    if (element) {
      const observer = new MutationObserver(this.handleResize);
      const config = { attributes: true, childList: true, subtree: true };
      observer.observe(element, config);
    }

    let Vue=this
    $('#singleContainer').niceScroll({  
        horizrailenabled: false,
        autohidemode: true,
        scrollbarid:'singleContainerScrollbar',
        cursorborder: "0px solid #fff",
        zindex: 45,
        railoffset: { left: -5 },
        cursordragontouch : true,
    })
    // $("#singleContainer").height(288.5);
    // if(document.getElementById('betviewScroll')!=null){
    //   var a = document.getElementById('betviewScroll').offsetHeight
    //   var b = 0
    //   if(document.getElementById('scrollFooter')!=null){
    //     b = document.getElementById('scrollFooter').offsetHeight
    //   }
      
    //   document.getElementById('betviewScroll').style.height = a + b +'px'
    // }

    // $(document).on('click', function (e) {
    //   if(Vue.showMULPopt){
      //  && $(e.target).closest(".select-value").length === 0
    //     if ($(e.target).closest(".options-wrap").length === 0) {
    //       Vue.toggleMULPopt()
    //     }
    //   }
    // });
    
    this.$store.commit("SELECTED_BETTAB", false);
    if(!this.betting.error){
      this.betMinMax()
    }
    EventBus.$on("stopBettingTimer", (res) => {
      this.clearTimer();
    //   if (res) {
    //     // this.pendingFlag = false;
    //     this.$store.commit('PENDING_FLAG', false)
    //     _.forEach(
    //       res.SYSTEM_DATA.betting,
    //       function (value) {
    //         if (
    //           value.wgStatus == "1" &&
    //           this.rbettype.indexOf(value.betType) != -1 &&
    //           value.sprtid == "1"
    //         ) {
    //           // this.pendingFlag = true;
    //           this.$store.commit('PENDING_FLAG', true)
    //         }
    //       }.bind(this)
    //     );
    //     this.checkPendingWager(res.SYSTEM_DATA.WagerID);
    //   }
    });
    // EventBus.$on("initBettingTimer", (res) => {
    //   this.startTimer();
    //   this.pendingWager.data = null;
    //   // this.pendingFlag = false;
    //   this.$store.commit('PENDING_FLAG', false)
    // });
    EventBus.$on("clearAllBetComboAmount", () => {
      this.allBetComboAmount = ''
    });
    EventBus.$on("resetKeyboard", () => {
      this.resetKeyboardAllow()
    });
    EventBus.$on("cancelBetForm", () => {
      this.cancelBetForm();
    });
    if (this.oddSelected) {
      EventBus.$emit("initBettingTimer");
    }
    EventBus.$on("processBet", () =>{
      this.showProcessBet()
      if(this.isProcessBet){
        // $('#checkOrder').attr('checked', 'checked')
        this.checkOrder()
      }else{
        // $('#checkOrder').removeAttr('checked')
        this.checkOrder()
      }
    })

    EventBus.$on("setBetMulpAmount", (res) => {
      this.betMulpAmount = res
    });
    // this.$refs.betAmount.focus()
  },
  beforeUnmount() {
    // Disconnect the MutationObserver when the component is being unmounted
    if (this.mutationObserver) {
      this.mutationObserver.disconnect();
    }
  },
  beforeDestroy() {
    EventBus.$off("stopBettingTimer");
    EventBus.$off("initBettingTimer");
    EventBus.$off("cancelBetForm");
    EventBus.$off("processBet");
    EventBus.$off("clearAllBetComboAmount");
    EventBus.$off("resetKeyboard");
    // EventBus.$off("processHdpChange");
    // EventBus.$off("processOdChangeUpDown");
    this.clearTimer();
  },
};
</script>
<style lang="scss" scoped>
@import "~@/styles/base/global";
</style>



// WEBPACK FOOTER //
// resources/wob/vue/apps/home/contentsLeft/bettingForm.vue